export const shippingCaptainNotifications = [
  {
    id: "5f4d54e6e630837c4977ed22",
    createdAt: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    type: "INAPP",
    category: "REPORT",
    isRead: true,
    title: "Captain Marinov, how did you perform this time?",
    template: "END_PERIOD",
    content: `<!doctype html>
<html lang="en" dir="auto" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<title></title>
<!--[if !mso]><!-->
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<!--<![endif]-->
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<style type="text/css">

#outlook a { padding:0; }
body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
p { display:block;margin:13px 0; }
</style>
<!--[if mso]>
<noscript>
<xml>
<o:OfficeDocumentSettings>
<o:AllowPNG/>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml>
</noscript>
<![endif]-->
<!--[if lte mso 11]>
<style type="text/css">

.h { width:100% !important; }
</style>
<![endif]-->
<!--[if !mso]><!-->
<link href="https://fonts.googleapis.com/css?family=Roboto:400,700" rel="stylesheet" type="text/css">
<!--<![endif]-->
<style type="text/css">

@media only screen and (min-width:599px) {
.o { width:100% !important; max-width: 100%; }
.t { width:17.6056% !important; max-width: 17.6056%; }
.y { width:2.8169% !important; max-width: 2.8169%; }
.iw { width:79.5775% !important; max-width: 79.5775%; }
.p { width:568px !important; max-width: 568px; }
.c2 { width:600px !important; max-width: 600px; }
.k { width:536px !important; max-width: 536px; }
.g { width:10.2612% !important; max-width: 10.2612%; }
.bp { width:17.5839% !important; max-width: 17.5839%; }
.x5 { width:2.9851% !important; max-width: 2.9851%; }
.x5q { width:17.584% !important; max-width: 17.584%; }
.s { width:10.4478% !important; max-width: 10.4478%; }
.thn { width:19.8511% !important; max-width: 19.8511%; }
.u { width:1.5385% !important; max-width: 1.5385%; }
.ui { width:78.6104% !important; max-width: 78.6104%; }
.v { width:6.7316% !important; max-width: 6.7316%; }
.oc { width:39.0431% !important; max-width: 39.0431%; }
.rz { width:39.043% !important; max-width: 39.043%; }
.n { width:10.5544% !important; max-width: 10.5544%; }
.s0 { width:0.7463% !important; max-width: 0.7463%; }
.thn0 { width:19.5451% !important; max-width: 19.5451%; }
.cq { width:68.4079% !important; max-width: 68.4079%; }
}
</style>
<style media="screen and (min-width:599px)">
.moz-text-html .o { width:100% !important; max-width: 100%; }
.moz-text-html .t { width:17.6056% !important; max-width: 17.6056%; }
.moz-text-html .y { width:2.8169% !important; max-width: 2.8169%; }
.moz-text-html .iw { width:79.5775% !important; max-width: 79.5775%; }
.moz-text-html .p { width:568px !important; max-width: 568px; }
.moz-text-html .c2 { width:600px !important; max-width: 600px; }
.moz-text-html .k { width:536px !important; max-width: 536px; }
.moz-text-html .g { width:10.2612% !important; max-width: 10.2612%; }
.moz-text-html .bp { width:17.5839% !important; max-width: 17.5839%; }
.moz-text-html .x5 { width:2.9851% !important; max-width: 2.9851%; }
.moz-text-html .x5q { width:17.584% !important; max-width: 17.584%; }
.moz-text-html .s { width:10.4478% !important; max-width: 10.4478%; }
.moz-text-html .thn { width:19.8511% !important; max-width: 19.8511%; }
.moz-text-html .u { width:1.5385% !important; max-width: 1.5385%; }
.moz-text-html .ui { width:78.6104% !important; max-width: 78.6104%; }
.moz-text-html .v { width:6.7316% !important; max-width: 6.7316%; }
.moz-text-html .oc { width:39.0431% !important; max-width: 39.0431%; }
.moz-text-html .rz { width:39.043% !important; max-width: 39.043%; }
.moz-text-html .n { width:10.5544% !important; max-width: 10.5544%; }
.moz-text-html .s0 { width:0.7463% !important; max-width: 0.7463%; }
.moz-text-html .thn0 { width:19.5451% !important; max-width: 19.5451%; }
.moz-text-html .cq { width:68.4079% !important; max-width: 68.4079%; }
</style>
<style type="text/css">

@media only screen and (max-width:598px) {
table.mq { width: 100% !important; }
td.mq { width: auto !important; }
}
</style>
<style type="text/css">

body {
-webkit-font-smoothing:antialiased;
-moz-osx-font-smoothing:grayscale;
}
a[x-apple-data-detectors] {
color: inherit !important;
text-decoration: none !important;
}
[data-markjs] { color: inherit; padding: 0; background: none; }
#MessageViewBody a {
color: inherit !important;
text-decoration: none!important;
}
[x-apple-data-detectors-type="calendar-event"] { color: inherit !important; -webkit-text-decoration-color: inherit !important; }
u + .emailify a[href^="tel:"],
u + .emailify a[href^="mailto:"],
u + .emailify a[href*="maps.google"] {
color: inherit !important;
text-decoration: none !important;
}div.wa { font-size: 0; }
@media only screen and (max-width:599px) {
.emailify { height:100% !important; margin:0 !important; padding:0 !important; width:100% !important; }
.mq img { width: 100%!important; max-width: 100%!important; height: auto!important; }
.a img { height: auto!important; }
.p3 { display: none!important; max-width: 0!important; max-height: 0!important; overflow: hidden!important; mso-hide: all!important; }
td.b td { background-size: cover!important; }
div.r > table > tbody > tr > td { direction: ltr!important; }
img { background-color: transparent!important; }
div.r.l > table > tbody > tr > td, div.r.l > div > table > tbody > tr > td { padding-top:8px!important }
div.r.e > table > tbody > tr > td, div.r.e > div > table > tbody > tr > td { padding-right:16px!important }
div.r.t7 > table > tbody > tr > td, div.r.t7 > div > table > tbody > tr > td { padding-bottom:8px!important }
div.r.ys > table > tbody > tr > td, div.r.ys > div > table > tbody > tr > td { padding-left:16px!important }
td.x.qk span, td.x.qk p, td.x.qk a, td.x.qk ol, td.x.qk ul, td.x.qk div, td.x.qk { font-size:20px!important }
div.r.cw > table > tbody > tr > td, div.r.cw > div > table > tbody > tr > td { padding-top:12px!important }
div.r.ke > table > tbody > tr > td, div.r.ke > div > table > tbody > tr > td { padding-bottom:12px!important }
td.x.xr span, td.x.xr p, td.x.xr a, td.x.xr ol, td.x.xr ul, td.x.xr div, td.x.xr { font-size:18px!important }
div.r.pt-0 > table > tbody > tr > td, div.r.pt-0 > div > table > tbody > tr > td { padding-top:0px!important }
div.r.pr-0 > table > tbody > tr > td, div.r.pr-0 > div > table > tbody > tr > td { padding-right:0px!important }
div.r.pb-0 > table > tbody > tr > td, div.r.pb-0 > div > table > tbody > tr > td { padding-bottom:0px!important }
div.r.pl-0 > table > tbody > tr > td, div.r.pl-0 > div > table > tbody > tr > td { padding-left:0px!important }
td.x.tn span, td.x.tn p, td.x.tn a, td.x.tn ol, td.x.tn ul, td.x.tn div, td.x.tn { font-size:14px!important }
td.x.lf span, td.x.lf p, td.x.lf a, td.x.lf ol, td.x.lf ul, td.x.lf div, td.x.lf { line-height:20px!important }
div.w.l > table > tbody > tr > td, div.w.l > div > table > tbody > tr > td { padding-top:8px!important; }
div.w.au > table > tbody > tr > td, div.w.au > div > table > tbody > tr > td { padding-right:12px!important; }
div.w.t7 > table > tbody > tr > td, div.w.t7 > div > table > tbody > tr > td { padding-bottom:8px!important; }
div.w.uo > table > tbody > tr > td, div.w.uo > div > table > tbody > tr > td { padding-left:12px!important; }
div.r.au > table > tbody > tr > td, div.r.au > div > table > tbody > tr > td { padding-right:12px!important }
div.r.uo > table > tbody > tr > td, div.r.uo > div > table > tbody > tr > td { padding-left:12px!important }
div.r.nh > table > tbody > tr > td, div.r.nh > div > table > tbody > tr > td { padding-bottom:24px!important }
td.b.tn a, td.b.tn span { font-size:14px!important }
td.b.xb > table { width:100%!important } td.xb > table > tbody > tr > td > a { display: block!important; width: 100%!important; padding-left: 0!important; padding-right: 0!important; }
td.b.xb > table { width:100%!important } td.xb > table > tbody > tr > td { width: 100%!important; padding-left: 0!important; padding-right: 0!important; }
td.b.p7 > table > tbody > tr > td:hover * { color:#000000!important }
td.b.ki > table > tbody > tr > td:hover, td.b.ki > table > tbody > tr > td:hover > a { background-color:#00BED6!important; }
.qkk td {
-webkit-transform: perspective(1px) translateZ(0);
transform: perspective(1px) translateZ(0);
box-shadow: 0 0 1px rgba(0, 0, 0, 0);
-webkit-transition-duration: 0.3s;
transition-duration: 0.3s;
-webkit-transition-property: transform;
transition-property: transform;
}
.qkk td:hover, .qkk td:focus, .qkk td:active {
-webkit-transform: scale(1.1);
transform: scale(1.1);
}
td.x.vp span, td.x.vp p, td.x.vp a, td.x.vp ol, td.x.vp ul, td.x.vp div, td.x.vp { font-size:16px!important }
td.x.pj span, td.x.pj p, td.x.pj a, td.x.pj ol, td.x.pj ul, td.x.pj div, td.x.pj { line-height:24px!important }
div.w.e > table > tbody > tr > td, div.w.e > div > table > tbody > tr > td { padding-right:16px!important; }
div.w.ys > table > tbody > tr > td, div.w.ys > div > table > tbody > tr > td { padding-left:16px!important; }
div.c.ck > table > tbody > tr > td.m { padding-bottom:8px!important; }
div.c.ck > table > tbody > tr > td > table > tbody > tr > td.m { padding-bottom:8px!important; }
div.c.z { width:48%!important; }
td.x.ae span, td.x.ae p, td.x.ae a, td.x.ae ol, td.x.ae ul, td.x.ae div, td.x.ae { font-size:8px!important }
td.x.waa span, td.x.waa p, td.x.waa a, td.x.waa ol, td.x.waa ul, td.x.waa div, td.x.waa { line-height:9px!important }
td.i.yw img, td.i.yw td { width:40px!important }
td.x.yc span, td.x.yc p, td.x.yc a, td.x.yc ol, td.x.yc ul, td.x.yc div, td.x.yc { font-size:6px!important }
}
@media (prefers-color-scheme: dark) {div.r.qc, div.r.qc > table { background-color:#04535D!important; }
div.r.yg * { color:#FFFFFE!important }
div.r.iu, div.r.iu > table { background-color:#0398AB!important; }
div.c.iu > table > tbody > tr > td { background-color:#0398AB!important; }
div.c.yg * { color:#FFFFFE!important }
div.r.rd, div.r.rd > table { background-color:#04454E!important; }
div.r.cy, div.r.cy > table { background-color:#028292!important; }
td.x.yg * { color:#FFFFFE!important }
div.w.cy, div.w.cy > div > table, div.w.cy > table, div.w.cy > table > tbody > tr > td { background-color:#028292!important; }
div.r.wo, div.r.wo > table { background-color:#EADFFC!important; }
div.r.bd * { color:#9962F8!important }
div.c.bd * { color:#9962F8!important }
td.x.bd * { color:#9962F8!important }
td.x.t5 a { color:#9962F8!important }
div.r.xt * { color:#000000!important }
td.x.xt * { color:#000000!important }
td.x.pl a { color:#000000!important }
div.r.df, div.r.df > table { background-color:#FF6E05!important; }
div.c.df > table > tbody > tr > td { background-color:#FF6E05!important; }
td.x.q8 a { color:#FFFFFE!important }
div.r.tv, div.r.tv > table { background-color:#FFD0E7!important; }
div.r.ik * { color:#FF1585!important }
div.c.ik * { color:#FF1585!important }
td.x.ik * { color:#FF1585!important }
td.x.ac a { color:#FF1585!important }
div.r.mo, div.r.mo > table { background-color:#2FCBA7!important; }
div.c.mo > table > tbody > tr > td { background-color:#2FCBA7!important; }
div.c.cy > table > tbody > tr > td { background-color:#028292!important; }
.gu { display: none!important; max-width: 0!important; max-height: 0!important; overflow: hidden!important; mso-hide: all!important; }
div.r.pb, div.r.pb > table { background-color:#05606C!important; }
div.c.rd > table > tbody > tr > td { background-color:#04454E!important; }
}
.qkk td {
-webkit-transform: perspective(1px) translateZ(0);
transform: perspective(1px) translateZ(0);
box-shadow: 0 0 1px rgba(0, 0, 0, 0);
-webkit-transition-duration: 0.3s;
transition-duration: 0.3s;
-webkit-transition-property: transform;
transition-property: transform;
}
.qkk td:hover, .qkk td:focus, .qkk td:active {
-webkit-transform: scale(1.1);
transform: scale(1.1);
}
td.b.p7 > table > tbody > tr > td:hover * { color:#000000!important }
td.b.ki > table > tbody > tr > td:hover, td.b.ki > table > tbody > tr > td:hover > a { background-color:#00BED6!important; }
</style>
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no, url=no">
<meta name="x-apple-disable-message-reformatting">
<meta name="color-scheme" content="light dark">
<meta name="supported-color-schemes" content="light dark">
<!--[if gte mso 9]>
<style>
a:link {
mso-style-priority: 99;
color: inherit;
text-decoration: none;
}
a:visited {
mso-style-priority: 99;
color: inherit;
text-decoration: none;
}
li { margin-left: -1em !important }
table, td, p, div, span, ul, ol, li, a, h1, h2, h3, h4, h5, h6 {
mso-hyphenate: none;
}
sup, sub { font-size: 100% !important; }
img { background-color: transparent !important; }
</style>
<![endif]-->
<!--[if mso]>
<style>
.co { background: transparent !important; background-color: transparent !important; mso-padding-alt: 0px !important; padding: 0px !important; border: 0px !important; border-top: 0px !important; border-right: 0px !important; border-bottom: 0px !important; border-left: 0px !important; }
</style>
<![endif]-->
<!--[if mso]><!-- -->
<style>
.sq > table > tbody > tr > td { border-collapse: collapse; }
</style>
<!--<![endif]-->
</head>
<body lang="en" link="#000000" vlink="#000000" class="emailify" style="mso-line-height-rule: exactly; mso-hyphenate: none; word-wrap: normal; word-spacing: normal; background-color: #f5f5f5;">
<div style="background-color:#f5f5f5;" lang="en" dir="auto">
<!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e t7 ys qc yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:568px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:99px;"><![endif]-->
<div class="t h m c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:17.6056%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:99px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Blue.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="99">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:452px;"><![endif]-->
<div class="iw h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:79.5775%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="right" class="x qk" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:right;color:#000000;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Period Recap</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r cw e ke ys iu yg" style="background:#00bed6;background-color:#00bed6;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#00bed6;background-color:#00bed6;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:568px;"><![endif]-->
<div class="p h iu yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="right" class="x xr" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:right;color:#ffffff;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">January 01 - January 15 2026</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><v:image style="border:0;height:192px;mso-position-horizontal:center;position:absolute;top:0;width:600px;z-index:-3;" src="https://signol-email-images.s3.eu-west-2.amazonaws.com/midperiodreport/header-shipping-March.png" xmlns:v="urn:schemas-microsoft-com:vml" /><v:rect style="border:0;height:192px;mso-position-horizontal:center;position:absolute;top:0;bottom:0;width:600px;z-index:-4;" fillcolor="#fffffe" stroke="false" strokecolor="none" strokeweight="0" xmlns:v="urn:schemas-microsoft-com:vml" /><![endif]-->
<div class="r pt-0 pr-0 pb-0 pl-0" style="background:#fffffe url('https://signol-email-images.s3.eu-west-2.amazonaws.com/midperiodreport/header-shipping-March.png') center center / cover no-repeat;background-position:center center;background-repeat:no-repeat;background-size:cover;background-color:#fffffe;margin:0px auto;max-width:600px;">
<div style="line-height:0;font-size:0;">
<table align="center" background="https://signol-email-images.s3.eu-west-2.amazonaws.com/midperiodreport/header-shipping-March.png" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe url('https://signol-email-images.s3.eu-west-2.amazonaws.com/midperiodreport/header-shipping-March.png') center center / cover no-repeat;background-position:center center;background-repeat:no-repeat;background-size:cover;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:600px;"><![endif]-->
<div class="c2 h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i xb" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="mq">
<tbody>
<tr>
<td style="width:600px;" class="mq">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/endperiodreport/header-shipping-January.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
</div>
<!--[if mso | IE]></td></tr></table></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys rd yg" style="background:#98e3eb;background-color:#98e3eb;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#98e3eb;background-color:#98e3eb;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 32px 16px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:center;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">You are having a positive impact on the planet.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r cw e ke ys cy yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:24px 32px 24px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf yg m" style="font-size:0;padding-bottom:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Dear Captain Marinov,</p></div>
</td>
</tr>
<tr>
<td style="font-size:0;padding:0;padding-bottom:0;word-break:break-word;" aria-hidden="true">
<div style="height:4px;line-height:4px;">&#8202;</div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r cw e ke ys cy yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:32px 32px 32px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x qk yg" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:center;color:#000000;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">How did you do this period?</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600" bgcolor="#fffffe"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="w l au t7 uo cy" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo wo bd" style="background:#eadffc;background-color:#eadffc;margin:0px auto;border-radius:10px 10px 0px 0px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#eadffc;background-color:#eadffc;width:100%;border-radius:10px 10px 0px 0px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 0px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:top;width:536px;"><![endif]-->
<div class="o h bd c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:top;" width="100%">
<tbody>
<tr>
<td align="left" class="x qk bd t5" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#9962f8;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Efficient SFOC</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div style="margin:0px auto;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
<tbody>
<tr>
<td style="direction:ltr;font-size:0;padding:0;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:568px;"><![endif]-->
<div class="o h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="font-size:0;padding:0;word-break:break-word;" aria-hidden="true">
<div style="height:0;line-height:0;">&#8202;</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo wo xt" style="background:#eadffc;background-color:#eadffc;margin:0px auto;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#eadffc;background-color:#eadffc;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 16px 8px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="o h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf xt pl" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">You did not achieve your goal this period, but you still saved 987 kg of fuel.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div style="margin:0px auto;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
<tbody>
<tr>
<td style="direction:ltr;font-size:0;padding:0;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:568px;"><![endif]-->
<div class="o h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="font-size:0;padding:0;word-break:break-word;" aria-hidden="true">
<div style="height:0;line-height:0;">&#8202;</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo wo" style="background:#eadffc;background-color:#eadffc;margin:0px auto;border-radius:0px 0px 10px 10px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#eadffc;background-color:#eadffc;width:100%;border-radius:0px 0px 10px 10px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="o h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i xb" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="mq">
<tbody>
<tr>
<td style="width:536px;" class="mq">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/behaviours/progressbar/purple_progress_90.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="536">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600" bgcolor="#fffffe"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="w l au t7 uo cy" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo df yg" style="background:#ff6e05;background-color:#ff6e05;margin:0px auto;border-radius:10px 10px 0px 0px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ff6e05;background-color:#ff6e05;width:100%;border-radius:10px 10px 0px 0px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 0px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:top;width:536px;"><![endif]-->
<div class="o h df yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:top;" width="100%">
<tbody>
<tr>
<td align="left" class="x qk yg q8" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#ffffff;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Optimal Trim</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div style="margin:0px auto;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
<tbody>
<tr>
<td style="direction:ltr;font-size:0;padding:0;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:568px;"><![endif]-->
<div class="o h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="font-size:0;padding:0;word-break:break-word;" aria-hidden="true">
<div style="height:0;line-height:0;">&#8202;</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo df yg" style="background:#ff6e05;background-color:#ff6e05;margin:0px auto;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ff6e05;background-color:#ff6e05;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 16px 8px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="o h df yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf yg q8" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#ffffff;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Congratulations, you implemented OT on 11 opportunities. </p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div style="margin:0px auto;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
<tbody>
<tr>
<td style="direction:ltr;font-size:0;padding:0;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:568px;"><![endif]-->
<div class="o h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="font-size:0;padding:0;word-break:break-word;" aria-hidden="true">
<div style="height:0;line-height:0;">&#8202;</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo df" style="background:#ff6e05;background-color:#ff6e05;margin:0px auto;border-radius:0px 0px 10px 10px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ff6e05;background-color:#ff6e05;width:100%;border-radius:0px 0px 10px 10px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="o h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i xb" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="mq">
<tbody>
<tr>
<td style="width:536px;" class="mq">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/behaviours/progressbar/orange_progress_100.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="536">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600" bgcolor="#fffffe"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="w l au t7 uo cy" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo tv ik" style="background:#ffd0e7;background-color:#ffd0e7;margin:0px auto;border-radius:10px 10px 0px 0px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffd0e7;background-color:#ffd0e7;width:100%;border-radius:10px 10px 0px 0px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 0px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:top;width:536px;"><![endif]-->
<div class="o h ik c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:top;" width="100%">
<tbody>
<tr>
<td align="left" class="x qk ik ac" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#ff1585;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Prompt Departure</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div style="margin:0px auto;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
<tbody>
<tr>
<td style="direction:ltr;font-size:0;padding:0;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:568px;"><![endif]-->
<div class="o h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="font-size:0;padding:0;word-break:break-word;" aria-hidden="true">
<div style="height:0;line-height:0;">&#8202;</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo tv xt" style="background:#ffd0e7;background-color:#ffd0e7;margin:0px auto;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffd0e7;background-color:#ffd0e7;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 16px 8px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="o h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf xt pl" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">You did not achieve your goal this period, but you still saved 326 kg of fuel.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div style="margin:0px auto;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
<tbody>
<tr>
<td style="direction:ltr;font-size:0;padding:0;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:568px;"><![endif]-->
<div class="o h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="font-size:0;padding:0;word-break:break-word;" aria-hidden="true">
<div style="height:0;line-height:0;">&#8202;</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo tv" style="background:#ffd0e7;background-color:#ffd0e7;margin:0px auto;border-radius:0px 0px 10px 10px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffd0e7;background-color:#ffd0e7;width:100%;border-radius:0px 0px 10px 10px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="o h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i xb" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="mq">
<tbody>
<tr>
<td style="width:536px;" class="mq">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/behaviours/progressbar/pink_progress_30.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="536">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600" bgcolor="#fffffe"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="w l au t7 uo cy" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo mo yg" style="background:#2fcba7;background-color:#2fcba7;margin:0px auto;border-radius:10px 10px 0px 0px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#2fcba7;background-color:#2fcba7;width:100%;border-radius:10px 10px 0px 0px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 0px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:top;width:536px;"><![endif]-->
<div class="o h mo yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:top;" width="100%">
<tbody>
<tr>
<td align="left" class="x qk yg" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#ffffff;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Efficient Auxiliary Engine Use </p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div style="margin:0px auto;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
<tbody>
<tr>
<td style="direction:ltr;font-size:0;padding:0;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:568px;"><![endif]-->
<div class="o h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="font-size:0;padding:0;word-break:break-word;" aria-hidden="true">
<div style="height:0;line-height:0;">&#8202;</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo mo yg" style="background:#2fcba7;background-color:#2fcba7;margin:0px auto;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#2fcba7;background-color:#2fcba7;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 16px 8px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="o h mo yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf yg" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#ffffff;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Congratulations, you implemented EAEU on 9 opportunities.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div style="margin:0px auto;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
<tbody>
<tr>
<td style="direction:ltr;font-size:0;padding:0;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:568px;"><![endif]-->
<div class="o h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="font-size:0;padding:0;word-break:break-word;" aria-hidden="true">
<div style="height:0;line-height:0;">&#8202;</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo mo" style="background:#2fcba7;background-color:#2fcba7;margin:0px auto;border-radius:0px 0px 10px 10px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#2fcba7;background-color:#2fcba7;width:100%;border-radius:0px 0px 10px 10px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="o h mo c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i xb" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="mq">
<tbody>
<tr>
<td style="width:536px;" class="mq">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/behaviours/progressbar/teal_progress_100.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="536">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e nh ys cy" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 32px 32px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="o h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td class="m" style="font-size:0;padding:0;padding-bottom:8px;word-break:break-word;" aria-hidden="true">
<div style="height:4px;line-height:4px;">&#8202;</div>
</td>
</tr>
<tr>
<td align="center" class="b tn xb p7 ki qkk" style="font-size:0;padding:0;padding-bottom:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;width:206px;line-height:100%;">
<tbody>
<tr>
<td align="center" bgcolor="#000000" class="co" role="presentation" style="background:#000000;border:none;border-radius:10px 10px 10px 10px;cursor:auto;mso-padding-alt:12px 0px 12px 0px;vertical-align:middle;" valign="middle">
<!--[if mso]><v:roundrect style="width:204px;height:52px;v-text-anchor:middle;" arcsize="38%" fill="t" stroke="f" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word"><w:anchorlock/><v:fill type="solid" color="#000000" /><v:textbox inset="0,0,0,0"><center><![endif]-->
<a href="#insertUrlLink" class="co" style="display:inline-block;width:206px;background-color:#000000;color:#ffffff;font-family:'Futura', 'Arial', sans-serif;font-size:13px;font-weight:normal;line-height:100%;margin:0;text-decoration:none;text-transform:none;padding:12px 0px 12px 0px;mso-padding-alt:0;border-radius:10px 10px 10px 10px;" target="_blank">
<span style="font-size:18px;font-family:'Futura', 'Arial', sans-serif;font-weight:700;color:#ffffff;line-height:156%;mso-line-height-alt:28px;">Log in or sign up</span>
</a>
<!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r cw e ke ys cy yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:24px 32px 24px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x qk yg" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:center;color:#000000;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">A reminder of your goals.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys cy" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:24px 32px 32px 32px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:top;width:55px;"><![endif]-->
<div class="g h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:10.2612%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:94px;"><![endif]-->
<div class="bp h m cy c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:17.5839%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x vp m" style="font-size:0;padding-bottom:4px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:center;color:#bf9dfb;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">ESFOC</p></div>
</td>
</tr>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;padding-bottom:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:94px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/behaviours/bubble/purple_goal_10.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="94">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:16px;"><![endif]-->
<div class="x5 h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.9851%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:94px;"><![endif]-->
<div class="bp h m cy c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:17.5839%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x vp m" style="font-size:0;padding-bottom:4px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:center;color:#ff6e05;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">OT</p></div>
</td>
</tr>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;padding-bottom:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:94px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/behaviours/bubble/orange_goal_11.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="94">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:16px;"><![endif]-->
<div class="x5 h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.9851%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:94px;"><![endif]-->
<div class="bp h m cy c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:17.5839%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x vp m" style="font-size:0;padding-bottom:4px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:center;color:#ff449d;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">PD</p></div>
</td>
</tr>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;padding-bottom:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:94px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/behaviours/bubble/pink_goal_4.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="94">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:16px;"><![endif]-->
<div class="x5 h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.9851%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:94px;"><![endif]-->
<div class="x5q h cy c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:17.584%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x qk pj m" style="font-size:0;padding-bottom:4px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:center;color:#62dbbf;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">EAEU</p></div>
</td>
</tr>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;padding-bottom:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:94px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/behaviours/bubble/teal_goal_9.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="94">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:56px;"><![endif]-->
<div class="s h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:10.4478%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r pt-0 pr-0 pb-0 pl-0 qc" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:600px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:600px;"><![endif]-->
<div class="o h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i xb gu" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="mq">
<tbody>
<tr>
<td style="width:600px;" class="mq">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/endperiodreport/trees_clear.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600" bgcolor="#2fcba7"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="w e ys" style="background:#2fcba7;background-color:#2fcba7;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#2fcba7;background-color:#2fcba7;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 16px 8px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo ck" style="background:#62dbbf;background-color:#62dbbf;margin:0px auto;border-radius:10px 10px 10px 10px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#62dbbf;background-color:#62dbbf;width:100%;border-radius:10px 10px 10px 10px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 24px 8px 24px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:520px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:103px;"><![endif]-->
<div class="thn h m c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:19.8511%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:100px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/endperiodreport/IMPACT_FUEL_SAVED.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:8px;"><![endif]-->
<div class="u h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:1.5385%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:408px;"><![endif]-->
<div class="ui h ck c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:78.6104%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf yg m" style="font-size:0;padding-bottom:16px;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">You saved:</p></div>
</td>
</tr>
<tr>
<td align="left" class="x qk yg" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#ffffff;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">24 tonnes of fuel</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600" bgcolor="#2fcba7"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="w e ys" style="background:#2fcba7;background-color:#2fcba7;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#2fcba7;background-color:#2fcba7;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys ck" style="background:#62dbbf;background-color:#62dbbf;margin:0px auto;border-radius:10px 10px 10px 10px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#62dbbf;background-color:#62dbbf;width:100%;border-radius:10px 10px 10px 10px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 24px 8px 24px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:520px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:103px;"><![endif]-->
<div class="thn h m c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:19.8511%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:100px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/endperiodreport/co2_equivalency_sun_panel.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:8px;"><![endif]-->
<div class="u h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:1.5385%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:408px;"><![endif]-->
<div class="ui h ck c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:78.6104%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf yg" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Your CO<sub style="line-height: 0; font-size: 75%;">2</sub> savings are the same as the energy saved by running 4.4 solar panels for 1 year.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600" bgcolor="#2fcba7"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="w e ys" style="background:#2fcba7;background-color:#2fcba7;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#2fcba7;background-color:#2fcba7;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r au uo ck" style="background:#62dbbf;background-color:#62dbbf;margin:0px auto;border-radius:10px 10px 10px 10px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#62dbbf;background-color:#62dbbf;width:100%;border-radius:10px 10px 10px 10px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 24px 8px 24px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:520px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:103px;"><![endif]-->
<div class="thn h m c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:19.8511%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:100px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/endperiodreport/charitable_donation.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:8px;"><![endif]-->
<div class="u h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:1.5385%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:408px;"><![endif]-->
<div class="ui h ck c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:78.6104%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf yg m" style="font-size:0;padding-bottom:16px;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Thanks to your achievements, Demo Line will:</p></div>
</td>
</tr>
<tr>
<td align="left" class="x qk yg" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#ffffff;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">donate $10 to the Ukraine Humanitarian Appeal</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e t7 ys pb" style="background:#e5f8fa;background-color:#e5f8fa;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#e5f8fa;background-color:#e5f8fa;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:568px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:38px;"><![endif]-->
<div class="v h m sq p3 c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:6.7316%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 0px 8px 0px;" bgcolor="transparent" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:38px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/newbehaviour/footer_wheel.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="38">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:221px;"><![endif]-->
<div class="oc h m sq rd z yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:39.0431%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background-color: #c3eff3; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 12px 8px 12px;" bgcolor="#c3eff3" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:left;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">You decide when it is <span style="font-weight:700;">safe and practical </span>to save fuel.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h p3" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:38px;"><![endif]-->
<div class="v h m sq p3 c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:6.7316%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 0px 8px 0px;" bgcolor="transparent" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:38px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/maritime_footer_thankyou.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="38">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:221px;"><![endif]-->
<div class="rz h sq rd z yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:39.043%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background-color: #c3eff3; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 12px 8px 12px;" bgcolor="#c3eff3" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:left;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">We and your company thank you for your hard work.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r pt-0 e t7 ys pb yg" style="background:#e5f8fa;background-color:#e5f8fa;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#e5f8fa;background-color:#e5f8fa;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:568px;"><![endif]-->
<div class="p h yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x ae waa yg q8" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:center;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">If this email was not meant for you, please let us know by replying.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e t7 ys" style="background:#b4b4b7;background-color:#b4b4b7;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#b4b4b7;background-color:#b4b4b7;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 32px 16px 32px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:56px;"><![endif]-->
<div class="n h m c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:10.5544%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:54px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Black-Icon.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="54">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:4px;"><![endif]-->
<div class="s0 h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:0.7463%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:104px;"><![endif]-->
<div class="thn0 h m c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:19.5451%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i a yw" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:72px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Black.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="72">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:4px;"><![endif]-->
<div class="s0 h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:0.7463%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:366px;"><![endif]-->
<div class="cq h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:68.4079%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="right" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:right;color:#000000;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">Any questions? You can simply reply to this email or find FAQs on the <a href="https://u11880263.ct.sendgrid.net/ls/click?upn=k55hJBaaYKnYHW4ARI-2BBXBqquf-2BtxNzjC6cpz6M71P103SgazTjF5Flj3DK8r7bR-2B9CKTId1iUXV6vIXaYgn3Q-3D-3DCwoC_CGdrXD359dka6t58CL7pvkMzfyXP3-2FqyuOQuIg7J1YQkWek6aoJE61PvdsZak0hC16CwjXnbJX0XiJXxR2JTDjI88xOYvwcWJg0ZZkz974yctxrsRTh-2BIZ3r-2FZk-2FpYhNXLDENg6rjsdAPRVW8-2FwdHXreMMHv1GJ5Fey5ow0FpW1TBy55h5JWwZ8VLLpgHNK28R1aLD-2BchmuyJuMbwQO2DNNsbeHTGOFAfAybX8PmzPmmBUsUiSbsiyyVbjk4yYezK5wO28mY52SQx0QIOirVdFunqMrhXGP-2BVWxSZYXsIWqGS4D8l-2F43xrQorSVS4Sc8F5018wDY4jEm4LGuwKUhlZz0iuaYisuNRoUCjIR7a98-3D" style="font-weight:700;color:#000000;text-decoration:none;" target="_blank"><span style="font-weight:700;text-decoration:underline;">support page</span></a> of your online account.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys" style="background:#000000;background-color:#000000;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#000000;background-color:#000000;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:4px 0px 4px 0px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:600px;"><![endif]-->
<div class="c2 h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x yc" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:8px;font-weight:400;line-height:125%;text-align:center;color:#9f9f9f;"><p style="Margin:0;mso-line-height-alt:10px;font-size:8px;line-height:125%;">&copy; SIGNOL 2025</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
</body>
</html>`,
    contentType: "HTML",
    attachments: [],
  },
  {
    id: "5f4d54e6e630837c4977ed23",
    createdAt: new Date(new Date().setMonth(new Date().getMonth() - 2)),
    type: "INAPP",
    category: "OTHER",
    isRead: false,
    title: "Captain Marinov, you reached a new milestone",
    template: "MILESTONE",
    content: `<!doctype html>
<html lang="en" dir="auto" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<title></title>
<!--[if !mso]><!-->
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<!--<![endif]-->
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<style type="text/css">

#outlook a { padding:0; }
body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
p { display:block;margin:13px 0; }
</style>
<!--[if mso]>
<noscript>
<xml>
<o:OfficeDocumentSettings>
<o:AllowPNG/>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml>
</noscript>
<![endif]-->
<!--[if lte mso 11]>
<style type="text/css">

.h { width:100% !important; }
</style>
<![endif]-->
<!--[if !mso]><!-->
<link href="https://fonts.googleapis.com/css?family=Roboto:400,700" rel="stylesheet" type="text/css">
<!--<![endif]-->
<style type="text/css">

@media only screen and (min-width:599px) {
.o { width:100% !important; max-width: 100%; }
.t { width:17.6056% !important; max-width: 17.6056%; }
.y { width:2.8169% !important; max-width: 2.8169%; }
.iw { width:79.5775% !important; max-width: 79.5775%; }
.c2 { width:600px !important; max-width: 600px; }
.k { width:536px !important; max-width: 536px; }
.h7 { width:272px !important; max-width: 272px; }
.gq { width:24px !important; max-width: 24px; }
.d { width:19.696% !important; max-width: 19.696%; }
.rz { width:2.3077% !important; max-width: 2.3077%; }
.j { width:77.9963% !important; max-width: 77.9963%; }
.v { width:6.7316% !important; max-width: 6.7316%; }
.oc { width:39.0431% !important; max-width: 39.0431%; }
.rz5 { width:39.043% !important; max-width: 39.043%; }
.p { width:568px !important; max-width: 568px; }
.n { width:10.5544% !important; max-width: 10.5544%; }
.s { width:0.7463% !important; max-width: 0.7463%; }
.thn { width:19.5451% !important; max-width: 19.5451%; }
.cq { width:68.4079% !important; max-width: 68.4079%; }
}
</style>
<style media="screen and (min-width:599px)">
.moz-text-html .o { width:100% !important; max-width: 100%; }
.moz-text-html .t { width:17.6056% !important; max-width: 17.6056%; }
.moz-text-html .y { width:2.8169% !important; max-width: 2.8169%; }
.moz-text-html .iw { width:79.5775% !important; max-width: 79.5775%; }
.moz-text-html .c2 { width:600px !important; max-width: 600px; }
.moz-text-html .k { width:536px !important; max-width: 536px; }
.moz-text-html .h7 { width:272px !important; max-width: 272px; }
.moz-text-html .gq { width:24px !important; max-width: 24px; }
.moz-text-html .d { width:19.696% !important; max-width: 19.696%; }
.moz-text-html .rz { width:2.3077% !important; max-width: 2.3077%; }
.moz-text-html .j { width:77.9963% !important; max-width: 77.9963%; }
.moz-text-html .v { width:6.7316% !important; max-width: 6.7316%; }
.moz-text-html .oc { width:39.0431% !important; max-width: 39.0431%; }
.moz-text-html .rz5 { width:39.043% !important; max-width: 39.043%; }
.moz-text-html .p { width:568px !important; max-width: 568px; }
.moz-text-html .n { width:10.5544% !important; max-width: 10.5544%; }
.moz-text-html .s { width:0.7463% !important; max-width: 0.7463%; }
.moz-text-html .thn { width:19.5451% !important; max-width: 19.5451%; }
.moz-text-html .cq { width:68.4079% !important; max-width: 68.4079%; }
</style>
<style type="text/css">

@media only screen and (max-width:598px) {
table.mq { width: 100% !important; }
td.mq { width: auto !important; }
}
</style>
<style type="text/css">

body {
-webkit-font-smoothing:antialiased;
-moz-osx-font-smoothing:grayscale;
}
a[x-apple-data-detectors] {
color: inherit !important;
text-decoration: none !important;
}
[data-markjs] { color: inherit; padding: 0; background: none; }
#MessageViewBody a {
color: inherit !important;
text-decoration: none!important;
}
[x-apple-data-detectors-type="calendar-event"] { color: inherit !important; -webkit-text-decoration-color: inherit !important; }
u + .emailify a[href^="tel:"],
u + .emailify a[href^="mailto:"],
u + .emailify a[href*="maps.google"] {
color: inherit !important;
text-decoration: none !important;
}div.wa { font-size: 0; }
@media only screen and (max-width:599px) {
.emailify { height:100% !important; margin:0 !important; padding:0 !important; width:100% !important; }
.mq img { width: 100%!important; max-width: 100%!important; height: auto!important; }
.a img { height: auto!important; }
.p3 { display: none!important; max-width: 0!important; max-height: 0!important; overflow: hidden!important; mso-hide: all!important; }
td.b td { background-size: cover!important; }
div.r > table > tbody > tr > td { direction: ltr!important; }
img { background-color: transparent!important; }
div.r.l > table > tbody > tr > td, div.r.l > div > table > tbody > tr > td { padding-top:8px!important }
div.r.e > table > tbody > tr > td, div.r.e > div > table > tbody > tr > td { padding-right:16px!important }
div.r.t7 > table > tbody > tr > td, div.r.t7 > div > table > tbody > tr > td { padding-bottom:8px!important }
div.r.ys > table > tbody > tr > td, div.r.ys > div > table > tbody > tr > td { padding-left:16px!important }
td.x.qk span, td.x.qk p, td.x.qk a, td.x.qk ol, td.x.qk ul, td.x.qk div, td.x.qk { font-size:20px!important }
div.r.pt-0 > table > tbody > tr > td, div.r.pt-0 > div > table > tbody > tr > td { padding-top:0px!important }
div.r.pr-0 > table > tbody > tr > td, div.r.pr-0 > div > table > tbody > tr > td { padding-right:0px!important }
div.r.pb-0 > table > tbody > tr > td, div.r.pb-0 > div > table > tbody > tr > td { padding-bottom:0px!important }
div.r.pl-0 > table > tbody > tr > td, div.r.pl-0 > div > table > tbody > tr > td { padding-left:0px!important }
div.r.cw > table > tbody > tr > td, div.r.cw > div > table > tbody > tr > td { padding-top:12px!important }
div.r.ke > table > tbody > tr > td, div.r.ke > div > table > tbody > tr > td { padding-bottom:12px!important }
td.x.tn span, td.x.tn p, td.x.tn a, td.x.tn ol, td.x.tn ul, td.x.tn div, td.x.tn { font-size:14px!important }
td.x.lf span, td.x.lf p, td.x.lf a, td.x.lf ol, td.x.lf ul, td.x.lf div, td.x.lf { line-height:20px!important }
div.r.nh > table > tbody > tr > td, div.r.nh > div > table > tbody > tr > td { padding-bottom:24px!important }
div.g.lfz > table > tbody > tr > td { padding-bottom:16px!important }
td.b.tn a, td.b.tn span { font-size:14px!important }
td.b.xb > table { width:100%!important } td.xb > table > tbody > tr > td > a { display: block!important; width: 100%!important; padding-left: 0!important; padding-right: 0!important; }
td.b.xb > table { width:100%!important } td.xb > table > tbody > tr > td { width: 100%!important; padding-left: 0!important; padding-right: 0!important; }
td.b.p7 > table > tbody > tr > td:hover * { color:#000000!important }
td.b.ki > table > tbody > tr > td:hover, td.b.ki > table > tbody > tr > td:hover > a { background-color:#00BED6!important; }
div.w.pt-0 > table > tbody > tr > td, div.w.pt-0 > div > table > tbody > tr > td { padding-top:0px!important; }
div.w.e > table > tbody > tr > td, div.w.e > div > table > tbody > tr > td { padding-right:16px!important; }
div.w.nh > table > tbody > tr > td, div.w.nh > div > table > tbody > tr > td { padding-bottom:24px!important; }
div.w.ys > table > tbody > tr > td, div.w.ys > div > table > tbody > tr > td { padding-left:16px!important; }
div.c.ck > table > tbody > tr > td.m { padding-bottom:8px!important; }
div.c.ck > table > tbody > tr > td > table > tbody > tr > td.m { padding-bottom:8px!important; }
div.c.z { width:48%!important; }
td.x.ae span, td.x.ae p, td.x.ae a, td.x.ae ol, td.x.ae ul, td.x.ae div, td.x.ae { font-size:8px!important }
td.x.waa span, td.x.waa p, td.x.waa a, td.x.waa ol, td.x.waa ul, td.x.waa div, td.x.waa { line-height:9px!important }
td.i.yw img, td.i.yw td { width:40px!important }
td.x.yc span, td.x.yc p, td.x.yc a, td.x.yc ol, td.x.yc ul, td.x.yc div, td.x.yc { font-size:6px!important }
}
@media (prefers-color-scheme: dark) {div.r.qc, div.r.qc > table { background-color:#04535D!important; }
div.r.yg * { color:#FFFFFE!important }
div.r.gs, div.r.gs > table { background-color:#22B18F!important; }
td.x.yg * { color:#FFFFFE!important }
div.w.gs, div.w.gs > div > table, div.w.gs > table, div.w.gs > table > tbody > tr > td { background-color:#22B18F!important; }
div.r.co, div.r.co > table { background-color:#248F76!important; }
div.r.pb, div.r.pb > table { background-color:#05606C!important; }
div.c.rd > table > tbody > tr > td { background-color:#04454E!important; }
div.c.yg * { color:#FFFFFE!important }
td.x.q8 a { color:#FFFFFE!important }
}
td.b.p7 > table > tbody > tr > td:hover * { color:#000000!important }
td.b.ki > table > tbody > tr > td:hover, td.b.ki > table > tbody > tr > td:hover > a { background-color:#00BED6!important; }
</style>
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no, url=no">
<meta name="x-apple-disable-message-reformatting">
<meta name="color-scheme" content="light dark">
<meta name="supported-color-schemes" content="light dark">
<!--[if gte mso 9]>
<style>
a:link {
mso-style-priority: 99;
color: inherit;
text-decoration: none;
}
a:visited {
mso-style-priority: 99;
color: inherit;
text-decoration: none;
}
li { margin-left: -1em !important }
table, td, p, div, span, ul, ol, li, a, h1, h2, h3, h4, h5, h6 {
mso-hyphenate: none;
}
sup, sub { font-size: 100% !important; }
img { background-color: transparent !important; }
</style>
<![endif]-->
<!--[if mso]>
<style>
.co8 { background: transparent !important; background-color: transparent !important; mso-padding-alt: 0px !important; padding: 0px !important; border: 0px !important; border-top: 0px !important; border-right: 0px !important; border-bottom: 0px !important; border-left: 0px !important; }
</style>
<![endif]-->
<!--[if mso]><!-- -->
<style>
.sq > table > tbody > tr > td { border-collapse: collapse; }
</style>
<!--<![endif]-->
</head>
<body lang="en" link="#000000" vlink="#000000" class="emailify" style="mso-line-height-rule: exactly; mso-hyphenate: none; word-wrap: normal; word-spacing: normal; background-color: #f5f5f5;">
<div style="background-color:#f5f5f5;" lang="en" dir="auto">
<!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e t7 ys qc yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:568px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:99px;"><![endif]-->
<div class="t h m c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:17.6056%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:99px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Blue.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="99">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:452px;"><![endif]-->
<div class="iw h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:79.5775%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="right" class="x qk" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:right;color:#000000;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Milestone</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r pt-0 pr-0 pb-0 pl-0" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:600px;"><![endif]-->
<div class="c2 h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i xb" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="mq">
<tbody>
<tr>
<td style="width:600px;" class="mq">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/milestones/Milestone.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r cw e ke ys gs yg" style="background:#dff9f3;background-color:#dff9f3;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#dff9f3;background-color:#dff9f3;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:20px 32px 12px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Dear Captain Marinov,</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e nh ys gs" style="background:#dff9f3;background-color:#dff9f3;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#dff9f3;background-color:#dff9f3;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:24px 16px 24px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:272px;"><![endif]-->
<div class="h7 h m sq c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse: separate; border-spacing: 0px; border: none; border-radius: 20px 20px 20px 20px; vertical-align: middle;" width="100%" bgcolor="transparent" valign="middle">
<tbody>
<tr>
<td align="left" class="i xb" style="border-collapse: separate; border-spacing: 0px; font-size: 0px; padding: 0; word-break: break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="mq">
<tbody>
<tr>
<td style="width:272px;" class="mq">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/milestones/Carbon_Leaf.png" style="border:0;border-radius:20px 20px 20px 20px;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="272">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:24px;"><![endif]-->
<div class="gq h g lfz" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:272px;"><![endif]-->
<div class="h7 h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn yg m" style="font-size:0;padding-bottom:16px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:18px;font-weight:700;line-height:133%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:24px;font-size:18px;line-height:133%;">Congratulations.</p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf yg m" style="font-size:0;padding-bottom:16px;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">You&rsquo;ve reached a new CO<sub style="line-height: 0; font-size: 75%;">2</sub> saving milestone of</p></div>
</td>
</tr>
<tr>
<td align="left" class="x yg m" style="font-size:0;padding-bottom:16px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">200 tonnes</p></div>
</td>
</tr>
<tr>
<td align="left" class="b tn xb p7 ki" style="font-size:0;padding:0;padding-bottom:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;width:182px;line-height:100%;">
<tbody>
<tr>
<td align="center" bgcolor="#000000" class="co8" role="presentation" style="background:#000000;border:none;border-radius:10px 10px 10px 10px;cursor:auto;mso-padding-alt:12px 0px 12px 0px;vertical-align:middle;" valign="middle">
<!--[if mso]><v:roundrect style="width:180px;height:47px;v-text-anchor:middle;" arcsize="43%" fill="t" stroke="f" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word"><w:anchorlock/><v:fill type="solid" color="#000000" /><v:textbox inset="0,0,0,0"><center><![endif]-->
<a href="#insertUrlLink" class="co8" style="display:inline-block;width:182px;background-color:#000000;color:#ffffff;font-family:'Futura', 'Arial', sans-serif;font-size:13px;font-weight:normal;line-height:100%;margin:0;text-decoration:none;text-transform:none;padding:12px 0px 12px 0px;mso-padding-alt:0;border-radius:10px 10px 10px 10px;" target="_blank">
<span style="font-size:18px;font-family:'Futura', 'Arial', sans-serif;font-weight:700;color:#ffffff;line-height:133%;mso-line-height-alt:24px;">See my impact</span>
</a>
<!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600" bgcolor="#dff9f3"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="w pt-0 e nh ys gs" style="background:#dff9f3;background-color:#dff9f3;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#dff9f3;background-color:#dff9f3;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 16px 12px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys co yg" style="background:#93e6d3;background-color:#93e6d3;margin:0px auto;border-radius:10px 10px 10px 10px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#93e6d3;background-color:#93e6d3;width:100%;border-radius:10px 10px 10px 10px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 24px 8px 24px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:520px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:102px;"><![endif]-->
<div class="d h m c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:19.696%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:100px;">
<img alt src="img/f58930bbc61713a18b433a4e09422e48.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:12px;"><![endif]-->
<div class="rz h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.3077%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:405px;"><![endif]-->
<div class="j h ck c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:77.9963%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Your CO<sub style="line-height: 0; font-size: 75%;">2</sub> savings are like the emissions from sailing 25% of the Suez Canal.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e t7 ys pb" style="background:#e5f8fa;background-color:#e5f8fa;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#e5f8fa;background-color:#e5f8fa;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:568px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:38px;"><![endif]-->
<div class="v h m sq p3 c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:6.7316%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 0px 8px 0px;" bgcolor="transparent" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:38px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/newbehaviour/footer_wheel.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="38">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:221px;"><![endif]-->
<div class="oc h m sq rd z yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:39.0431%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background-color: #c3eff3; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 12px 8px 12px;" bgcolor="#c3eff3" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:left;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">You decide when it is <span style="font-weight:700;">safe and practical </span>to save fuel.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h g p3" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:38px;"><![endif]-->
<div class="v h m sq p3 c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:6.7316%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 0px 8px 0px;" bgcolor="transparent" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:38px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/maritime_footer_thankyou.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="38">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:221px;"><![endif]-->
<div class="rz5 h sq rd z yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:39.043%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background-color: #c3eff3; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 12px 8px 12px;" bgcolor="#c3eff3" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:left;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">We and your company thank you for your hard work.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r pt-0 e t7 ys pb yg" style="background:#e5f8fa;background-color:#e5f8fa;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#e5f8fa;background-color:#e5f8fa;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:568px;"><![endif]-->
<div class="p h yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x ae waa yg q8" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:center;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">If this email was not meant for you, please let us know by replying.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e t7 ys" style="background:#b4b4b7;background-color:#b4b4b7;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#b4b4b7;background-color:#b4b4b7;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 32px 16px 32px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:56px;"><![endif]-->
<div class="n h m c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:10.5544%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:54px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Black-Icon.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="54">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:4px;"><![endif]-->
<div class="s h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:0.7463%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:104px;"><![endif]-->
<div class="thn h m c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:19.5451%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i a yw" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:72px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Black.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="72">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:4px;"><![endif]-->
<div class="s h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:0.7463%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:366px;"><![endif]-->
<div class="cq h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:68.4079%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="right" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:right;color:#000000;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">Any questions? You can simply reply to this email or find FAQs on the <a href="https://u11880263.ct.sendgrid.net/ls/click?upn=k55hJBaaYKnYHW4ARI-2BBXBqquf-2BtxNzjC6cpz6M71P103SgazTjF5Flj3DK8r7bR-2B9CKTId1iUXV6vIXaYgn3Q-3D-3DCwoC_CGdrXD359dka6t58CL7pvkMzfyXP3-2FqyuOQuIg7J1YQkWek6aoJE61PvdsZak0hC16CwjXnbJX0XiJXxR2JTDjI88xOYvwcWJg0ZZkz974yctxrsRTh-2BIZ3r-2FZk-2FpYhNXLDENg6rjsdAPRVW8-2FwdHXreMMHv1GJ5Fey5ow0FpW1TBy55h5JWwZ8VLLpgHNK28R1aLD-2BchmuyJuMbwQO2DNNsbeHTGOFAfAybX8PmzPmmBUsUiSbsiyyVbjk4yYezK5wO28mY52SQx0QIOirVdFunqMrhXGP-2BVWxSZYXsIWqGS4D8l-2F43xrQorSVS4Sc8F5018wDY4jEm4LGuwKUhlZz0iuaYisuNRoUCjIR7a98-3D" style="font-weight:700;color:#000000;text-decoration:none;" target="_blank"><span style="font-weight:700;text-decoration:underline;">support page</span></a> of your online account.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys" style="background:#000000;background-color:#000000;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#000000;background-color:#000000;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:4px 0px 4px 0px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:600px;"><![endif]-->
<div class="c2 h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x yc" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:8px;font-weight:400;line-height:125%;text-align:center;color:#9f9f9f;"><p style="Margin:0;mso-line-height-alt:10px;font-size:8px;line-height:125%;">&copy; SIGNOL 2025</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
</body>
</html>`,
    contentType: "HTML",
  },
  {
    id: "5f4d54e6e630837c4977ed24",
    createdAt: new Date(new Date().getFullYear(), new Date().getMonth() - 2, 7),
    type: "INAPP",
    category: "REPORT",
    isRead: false,
    title: "Captain Marinov, how do we measure OT?",
    template: "MIDMONTHLY",
    content: `<!doctype html>
<html lang="en" dir="auto" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<title></title>
<!--[if !mso]><!-->
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<!--<![endif]-->
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<style type="text/css">

#outlook a { padding:0; }
body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
p { display:block;margin:13px 0; }
</style>
<!--[if mso]>
<noscript>
<xml>
<o:OfficeDocumentSettings>
<o:AllowPNG/>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml>
</noscript>
<![endif]-->
<!--[if lte mso 11]>
<style type="text/css">

.h { width:100% !important; }
</style>
<![endif]-->
<!--[if !mso]><!-->
<link href="https://fonts.googleapis.com/css?family=Roboto:400,700" rel="stylesheet" type="text/css">
<!--<![endif]-->
<style type="text/css">

@media only screen and (min-width:599px) {
.o { width:100% !important; max-width: 100%; }
.t { width:17.6056% !important; max-width: 17.6056%; }
.y { width:2.8169% !important; max-width: 2.8169%; }
.iw { width:79.5775% !important; max-width: 79.5775%; }
.p { width:568px !important; max-width: 568px; }
.c2 { width:600px !important; max-width: 600px; }
.k { width:536px !important; max-width: 536px; }
.l { width:31.3433% !important; max-width: 31.3433%; }
.x5 { width:2.9851% !important; max-width: 2.9851%; }
.k8 { width:31.3432% !important; max-width: 31.3432%; }
.i8 { width:552px !important; max-width: 552px; }
.rf { width:14.1791% !important; max-width: 14.1791%; }
.cq { width:82.8358% !important; max-width: 82.8358%; }
.z { width:300px !important; max-width: 300px; }
.mj-column-px-0 { width:0px !important; max-width: 0px; }
.v { width:6.7316% !important; max-width: 6.7316%; }
.oc { width:39.0431% !important; max-width: 39.0431%; }
.rz { width:39.043% !important; max-width: 39.043%; }
.n { width:10.5544% !important; max-width: 10.5544%; }
.s { width:0.7463% !important; max-width: 0.7463%; }
.thn { width:19.5451% !important; max-width: 19.5451%; }
.cqe { width:68.4079% !important; max-width: 68.4079%; }
}
</style>
<style media="screen and (min-width:599px)">
.moz-text-html .o { width:100% !important; max-width: 100%; }
.moz-text-html .t { width:17.6056% !important; max-width: 17.6056%; }
.moz-text-html .y { width:2.8169% !important; max-width: 2.8169%; }
.moz-text-html .iw { width:79.5775% !important; max-width: 79.5775%; }
.moz-text-html .p { width:568px !important; max-width: 568px; }
.moz-text-html .c2 { width:600px !important; max-width: 600px; }
.moz-text-html .k { width:536px !important; max-width: 536px; }
.moz-text-html .l { width:31.3433% !important; max-width: 31.3433%; }
.moz-text-html .x5 { width:2.9851% !important; max-width: 2.9851%; }
.moz-text-html .k8 { width:31.3432% !important; max-width: 31.3432%; }
.moz-text-html .i8 { width:552px !important; max-width: 552px; }
.moz-text-html .rf { width:14.1791% !important; max-width: 14.1791%; }
.moz-text-html .cq { width:82.8358% !important; max-width: 82.8358%; }
.moz-text-html .z { width:300px !important; max-width: 300px; }
.moz-text-html .mj-column-px-0 { width:0px !important; max-width: 0px; }
.moz-text-html .v { width:6.7316% !important; max-width: 6.7316%; }
.moz-text-html .oc { width:39.0431% !important; max-width: 39.0431%; }
.moz-text-html .rz { width:39.043% !important; max-width: 39.043%; }
.moz-text-html .n { width:10.5544% !important; max-width: 10.5544%; }
.moz-text-html .s { width:0.7463% !important; max-width: 0.7463%; }
.moz-text-html .thn { width:19.5451% !important; max-width: 19.5451%; }
.moz-text-html .cqe { width:68.4079% !important; max-width: 68.4079%; }
</style>
<style type="text/css">

@media only screen and (max-width:598px) {
table.m { width: 100% !important; }
td.m { width: auto !important; }
}
</style>
<style type="text/css">

body {
-webkit-font-smoothing:antialiased;
-moz-osx-font-smoothing:grayscale;
}
a[x-apple-data-detectors] {
color: inherit !important;
text-decoration: none !important;
}
[data-markjs] { color: inherit; padding: 0; background: none; }
#MessageViewBody a {
color: inherit !important;
text-decoration: none!important;
}
[x-apple-data-detectors-type="calendar-event"] { color: inherit !important; -webkit-text-decoration-color: inherit !important; }
u + .emailify a[href^="tel:"],
u + .emailify a[href^="mailto:"],
u + .emailify a[href*="maps.google"] {
color: inherit !important;
text-decoration: none !important;
}div.w { font-size: 0; }
@media only screen and (max-width:599px) {
.emailify { height:100% !important; margin:0 !important; padding:0 !important; width:100% !important; }
.m img { width: 100%!important; max-width: 100%!important; height: auto!important; }
.a img { height: auto!important; }
.p3 { display: none!important; max-width: 0!important; max-height: 0!important; overflow: hidden!important; mso-hide: all!important; }
td.b td { background-size: cover!important; }
div.r > table > tbody > tr > td { direction: ltr!important; }
img { background-color: transparent!important; }
div.r.lp > table > tbody > tr > td, div.r.lp > div > table > tbody > tr > td { padding-top:8px!important }
div.r.ey > table > tbody > tr > td, div.r.ey > div > table > tbody > tr > td { padding-right:16px!important }
div.r.t7 > table > tbody > tr > td, div.r.t7 > div > table > tbody > tr > td { padding-bottom:8px!important }
div.r.ys > table > tbody > tr > td, div.r.ys > div > table > tbody > tr > td { padding-left:16px!important }
td.x.qk span, td.x.qk p, td.x.qk a, td.x.qk ol, td.x.qk ul, td.x.qk div, td.x.qk { font-size:20px!important }
div.r.f > table > tbody > tr > td, div.r.f > div > table > tbody > tr > td { padding-top:2px!important }
div.r.n1 > table > tbody > tr > td, div.r.n1 > div > table > tbody > tr > td { padding-bottom:2px!important }
div.r.pt-0 > table > tbody > tr > td, div.r.pt-0 > div > table > tbody > tr > td { padding-top:0px!important }
div.r.pr-0 > table > tbody > tr > td, div.r.pr-0 > div > table > tbody > tr > td { padding-right:0px!important }
div.r.pb-0 > table > tbody > tr > td, div.r.pb-0 > div > table > tbody > tr > td { padding-bottom:0px!important }
div.r.pl-0 > table > tbody > tr > td, div.r.pl-0 > div > table > tbody > tr > td { padding-left:0px!important }
div.r.dx > table > tbody > tr > td, div.r.dx > div > table > tbody > tr > td { padding-right:24px!important }
div.r.xr > table > tbody > tr > td, div.r.xr > div > table > tbody > tr > td { padding-left:24px!important }
td.x.tn span, td.x.tn p, td.x.tn a, td.x.tn ol, td.x.tn ul, td.x.tn div, td.x.tn { font-size:14px!important }
td.x.lf span, td.x.lf p, td.x.lf a, td.x.lf ol, td.x.lf ul, td.x.lf div, td.x.lf { line-height:20px!important }
div.r.fz > table > tbody > tr > td, div.r.fz > div > table > tbody > tr > td { padding-top:24px!important }
div.r.nh > table > tbody > tr > td, div.r.nh > div > table > tbody > tr > td { padding-bottom:24px!important }
td.b.tn a, td.b.tn span { font-size:14px!important }
td.b.xb > table { width:100%!important } td.xb > table > tbody > tr > td > a { display: block!important; width: 100%!important; padding-left: 0!important; padding-right: 0!important; }
td.b.xb > table { width:100%!important } td.xb > table > tbody > tr > td { width: 100%!important; padding-left: 0!important; padding-right: 0!important; }
td.b.p7 > table > tbody > tr > td:hover * { color:#000000!important }
td.b.ki > table > tbody > tr > td:hover, td.b.ki > table > tbody > tr > td:hover > a { background-color:#00BED6!important; }
.qkk td {
-webkit-transform: perspective(1px) translateZ(0);
transform: perspective(1px) translateZ(0);
box-shadow: 0 0 1px rgba(0, 0, 0, 0);
-webkit-transition-duration: 0.3s;
transition-duration: 0.3s;
-webkit-transition-property: transform;
transition-property: transform;
}
.qkk td:hover, .qkk td:focus, .qkk td:active {
-webkit-transform: scale(1.1);
transform: scale(1.1);
}
div.c.hl > table > tbody > tr > td { padding-top:4px!important }
div.c.fjj > table > tbody > tr > td { padding-right:4px!important }
div.c.p3w > table > tbody > tr > td { padding-bottom:4px!important }
div.c.zd > table > tbody > tr > td { padding-left:4px!important }
div.c.ey > table > tbody > tr > td { padding-right:16px!important }
div.c.ys > table > tbody > tr > td { padding-left:16px!important }
div.g.mb-0 > table > tbody > tr > td { padding-bottom:0px!important }
div.c.fz > table > tbody > tr > td { padding-top:24px!important }
div.c.dx > table > tbody > tr > td { padding-right:24px!important }
div.c.nh > table > tbody > tr > td { padding-bottom:24px!important }
div.c.xr > table > tbody > tr > td { padding-left:24px!important }
div.c.zx { width:48%!important; }
td.x.ae span, td.x.ae p, td.x.ae a, td.x.ae ol, td.x.ae ul, td.x.ae div, td.x.ae { font-size:8px!important }
td.x.waa span, td.x.waa p, td.x.waa a, td.x.waa ol, td.x.waa ul, td.x.waa div, td.x.waa { line-height:9px!important }
td.i.yw img, td.i.yw td { width:40px!important }
td.x.yc span, td.x.yc p, td.x.yc a, td.x.yc ol, td.x.yc ul, td.x.yc div, td.x.yc { font-size:6px!important }
}
@media (prefers-color-scheme: dark) {div.r.pb, div.r.pb > table { background-color:#05606C!important; }
div.r.yg * { color:#FFFFFE!important }
div.r.iu, div.r.iu > table { background-color:#0398AB!important; }
div.c.iu > table > tbody > tr > td { background-color:#0398AB!important; }
div.c.yg * { color:#FFFFFE!important }
div.r.cy, div.r.cy > table { background-color:#028292!important; }
div.c.cy > table > tbody > tr > td { background-color:#028292!important; }
td.x.x9 * { color:#03A5B9!important }
td.x.yg * { color:#FFFFFE!important }
div.c.pb > table > tbody > tr > td { background-color:#05606C!important; }
div.c.rd > table > tbody > tr > td { background-color:#04454E!important; }
td.x.q8 a { color:#FFFFFE!important }
}
.qkk td {
-webkit-transform: perspective(1px) translateZ(0);
transform: perspective(1px) translateZ(0);
box-shadow: 0 0 1px rgba(0, 0, 0, 0);
-webkit-transition-duration: 0.3s;
transition-duration: 0.3s;
-webkit-transition-property: transform;
transition-property: transform;
}
.qkk td:hover, .qkk td:focus, .qkk td:active {
-webkit-transform: scale(1.1);
transform: scale(1.1);
}
td.b.p7 > table > tbody > tr > td:hover * { color:#000000!important }
td.b.ki > table > tbody > tr > td:hover, td.b.ki > table > tbody > tr > td:hover > a { background-color:#00BED6!important; }
</style>
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no, url=no">
<meta name="x-apple-disable-message-reformatting">
<meta name="color-scheme" content="light dark">
<meta name="supported-color-schemes" content="light dark">
<!--[if gte mso 9]>
<style>
a:link {
mso-style-priority: 99;
color: inherit;
text-decoration: none;
}
a:visited {
mso-style-priority: 99;
color: inherit;
text-decoration: none;
}
li { margin-left: -1em !important }
table, td, p, div, span, ul, ol, li, a, h1, h2, h3, h4, h5, h6 {
mso-hyphenate: none;
}
sup, sub { font-size: 100% !important; }
img { background-color: transparent !important; }
</style>
<![endif]-->
<!--[if mso]>
<style>
.co { background: transparent !important; background-color: transparent !important; mso-padding-alt: 0px !important; padding: 0px !important; border: 0px !important; border-top: 0px !important; border-right: 0px !important; border-bottom: 0px !important; border-left: 0px !important; }
</style>
<![endif]-->
<!--[if mso]><!-- -->
<style>
.sq > table > tbody > tr > td { border-collapse: collapse; }
</style>
<!--<![endif]-->
</head>
<body lang="en" link="#ffffff" vlink="#ffffff" class="emailify" style="mso-line-height-rule: exactly; mso-hyphenate: none; word-wrap: normal; word-spacing: normal; background-color: #f5f5f5;">
<div style="background-color:#f5f5f5;" lang="en" dir="auto">
<!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r lp ey t7 ys pb yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:568px;"><![endif]-->
<div class="o h w" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:99px;"><![endif]-->
<div class="t hc" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:17.6056%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:99px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Blue.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="99">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:452px;"><![endif]-->
<div class="iw h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:79.5775%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="right" class="x qk" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:right;color:#000000;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Mid-Period Update</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r f ey n1 ys iu yg" style="background:#00bed6;background-color:#00bed6;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#00bed6;background-color:#00bed6;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:568px;"><![endif]-->
<div class="p h iu yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="right" class="x qk" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:right;color:#ffffff;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">January 01 - January 15 2026</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><v:image style="border:0;height:192px;mso-position-horizontal:center;position:absolute;top:0;width:600px;z-index:-3;" src="https://signol-email-images.s3.eu-west-2.amazonaws.com/midperiodreport/header-shipping-March.png" xmlns:v="urn:schemas-microsoft-com:vml" /><v:rect style="border:0;height:192px;mso-position-horizontal:center;position:absolute;top:0;bottom:0;width:600px;z-index:-4;" fillcolor="#fffffe" stroke="false" strokecolor="none" strokeweight="0" xmlns:v="urn:schemas-microsoft-com:vml" /><![endif]-->
<div class="r pt-0 pr-0 pb-0 pl-0" style="background:#fffffe url('https://signol-email-images.s3.eu-west-2.amazonaws.com/midperiodreport/header-shipping-March.png') center center / cover no-repeat;background-position:center center;background-repeat:no-repeat;background-size:cover;background-color:#fffffe;margin:0px auto;max-width:600px;">
<div style="line-height:0;font-size:0;">
<table align="center" background="https://signol-email-images.s3.eu-west-2.amazonaws.com/midperiodreport/header-shipping-March.png" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe url('https://signol-email-images.s3.eu-west-2.amazonaws.com/midperiodreport/header-shipping-March.png') center center / cover no-repeat;background-position:center center;background-repeat:no-repeat;background-size:cover;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:600px;"><![endif]-->
<div class="c2 h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i xb" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="m">
<tbody>
<tr>
<td style="width:600px;" class="m">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/midperiodreport/header-shipping-March.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
</div>
<!--[if mso | IE]></td></tr></table></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r dx xr cy yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:24px 32px 0px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf" style="font-size:0;padding-bottom:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#777777;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Dear Captain Marinov,</p></div>
</td>
</tr>
<tr>
<td style="font-size:0;padding:0;padding-bottom:0;word-break:break-word;" aria-hidden="true">
<div style="height:4px;line-height:4px;">&#8202;</div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r fz ey nh ys cy yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:32px 32px 32px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x qk" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:center;color:#000000;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">03, Jan is your most fuel-efficient report so far this period.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r ey nh ys cy yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 32px 32px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h w" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:168px;"><![endif]-->
<div class="l hc" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:31.3433%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;padding-bottom:8px;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:44px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/midperiodreport/DATE.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="44">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td align="center" class="x tn" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:18px;font-weight:700;line-height:133%;text-align:center;color:#000000;"><p style="Margin:0;mso-line-height-alt:24px;font-size:18px;line-height:133%;">03 Jan 2026</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:16px;"><![endif]-->
<div class="x5 h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.9851%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:168px;"><![endif]-->
<div class="l hc" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:31.3433%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;padding-bottom:8px;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:44px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/midperiodreport/LOCATION.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="44">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td align="center" class="x tn" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:18px;font-weight:700;line-height:133%;text-align:center;color:#000000;"><p style="Margin:0;mso-line-height-alt:24px;font-size:18px;line-height:133%;">AEJEA > KEMBA</p></div>
</td>
</tr>
<tr>
<td align="center" class="x tn" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:center;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Demo Vessel</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:16px;"><![endif]-->
<div class="x5 h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.9851%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:167px;"><![endif]-->
<div class="k8 h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:31.3432%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;padding-bottom:8px;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:44px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/FUEL_SAVED.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="44">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td align="center" class="x tn" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:18px;font-weight:700;line-height:133%;text-align:center;color:#000000;"><p style="Margin:0;mso-line-height-alt:24px;font-size:18px;line-height:133%;">2 tonnes</p></div>
</td>
</tr>
<tr>
<td align="center" class="x tn" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:center;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Fuel saved </p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r ey nh ys cy" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 32px 32px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h w" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:536px;"><![endif]-->
<div class="o h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td style="font-size:0;padding:0;padding-bottom:8px;word-break:break-word;" aria-hidden="true">
<div style="height:4px;line-height:4px;">&#8202;</div>
</td>
</tr>
<tr>
<td align="center" class="b tn xb p7 ki qkk" style="font-size:0;padding:0;padding-bottom:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;width:302px;line-height:100%;">
<tbody>
<tr>
<td align="center" bgcolor="#000000" class="co" role="presentation" style="background:#000000;border:none;border-radius:10px 10px 10px 10px;cursor:auto;mso-padding-alt:12px 0px 12px 0px;vertical-align:middle;" valign="middle">
<!--[if mso]><v:roundrect style="width:300px;height:48px;v-text-anchor:middle;" arcsize="42%" fill="t" stroke="f" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word"><w:anchorlock/><v:fill type="solid" color="#000000" /><v:textbox inset="0,0,0,0"><center><![endif]-->
<a href="#insertUrlLink" class="co" style="display:inline-block;width:302px;background-color:#000000;color:#ffffff;font-family:'Futura', 'Arial', sans-serif;font-size:13px;font-weight:normal;line-height:100%;margin:0;text-decoration:none;text-transform:none;padding:12px 0px 12px 0px;mso-padding-alt:0;border-radius:10px 10px 10px 10px;" target="_blank">
<span style="font-size:18px;font-family:'Futura', 'Arial', sans-serif;font-weight:700;color:#ffffff;line-height:133%;mso-line-height-alt:24px;">Access your online account</span>
</a>
<!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r fz ey nh ys pb" style="background:#e6e6e6;background-color:#e6e6e6;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#e6e6e6;background-color:#e6e6e6;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:24px 24px 24px 24px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:552px;"><![endif]-->
<div class="i8 h sq cy yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background-color: #fffffe; border: none; border-radius: 20px 20px 20px 20px; vertical-align: middle; padding: 24px 24px 24px 24px;" bgcolor="#fffffe" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;padding-bottom:4px;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="m">
<tbody>
<tr>
<td style="width:190px;" class="m">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/SignolRemindersLogo.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="190">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td style="font-size:0;padding:0;padding-bottom:4px;word-break:break-word;" aria-hidden="true">
<div style="height:4px;line-height:4px;">&#8202;</div>
</td>
</tr>
<tr>
<td align="center" class="x tn x9" style="font-size:0;padding-bottom:4px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:18px;font-weight:700;line-height:156%;text-align:center;color:#00bed6;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Efficient Auxiliary Engine Use</p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf yg" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#05606c;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Are you running your auxiliary engines at low loads? This can lead to turbocharger fouling. Utilise ship&rsquo;s PMS to prevent prolonged running of multiple engines at low loads.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r fz ey nh ys" style="background:#ffe2cd;background-color:#ffe2cd;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffe2cd;background-color:#ffe2cd;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:32px 32px 32px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h w" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:75px;"><![endif]-->
<div class="rf hhl fjj p3w zd sq c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:14.1791%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background-color: #ff8b37; border: none; border-radius: 50px 50px 50px 50px; vertical-align: middle; padding: 8px 8px 8px 8px;" bgcolor="#ff8b37" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:59px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/notification_bell_icon.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="59">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:16px;"><![endif]-->
<div class="x5 h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.9851%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:443px;"><![endif]-->
<div class="cq h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:82.8358%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x qk" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:center;color:#000000;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Here's a reminder of how we measure OT.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r ey ys" style="background:#ffe2cd;background-color:#ffe2cd;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffe2cd;background-color:#ffe2cd;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:1px 24px 24px 24px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:552px;"><![endif]-->
<div class="i8 h ey ys sq pb yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background-color: #fffffe; border: none; border-radius: 20px 20px 20px 20px; vertical-align: middle; padding: 24px 24px 24px 24px;" bgcolor="#fffffe" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x tn" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:18px;font-weight:700;line-height:133%;text-align:left;color:#ff6e05;"><p style="Margin:0;mso-line-height-alt:24px;font-size:18px;line-height:133%;">OT Success Definition:</p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Comply with optimal trim given by your vessel's trim table.</p></div>
</td>
</tr>
<tr>
<td style="font-size:0;padding:0;padding-bottom:8px;word-break:break-word;" aria-hidden="true">
<div style="height:12px;line-height:12px;">&#8202;</div>
</td>
</tr>
<tr>
<td align="left" class="x tn" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:18px;font-weight:700;line-height:133%;text-align:left;color:#ff6e05;"><p style="Margin:0;mso-line-height-alt:24px;font-size:18px;line-height:133%;">Exclusions:</p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><ul style="font-size:18px;line-height:156%;color:#000000;padding-left:25px;font-weight:400;Margin-top:0;Margin-bottom:0;mso-line-height-alt:28px;"><li style="Margin:0;"> When the vessel is not at sea</li><li style="Margin:0;">When some data is missing e.g. observed distance</li><li style="Margin:0;">Main engine not running</li><li style="Margin:0;">When the data appears faulty e.g. mean draft > 10</li><li style="Margin:0;">When wind speed is &ge; BF6</li><li style="Margin:0;">When the vessel speed is < 10kts or > 14kts</li></ul></div>
</td>
</tr>
<tr>
<td style="font-size:0;padding:0;padding-bottom:8px;word-break:break-word;" aria-hidden="true">
<div style="height:4px;line-height:4px;">&#8202;</div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Head to the goals page in your online account to find out how we calculate your OT fuel savings.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r pt-0 pr-0 pb-0 pl-0 cy" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:300px;"><![endif]-->
<div class="z hc" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i xb" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="m">
<tbody>
<tr>
<td style="width:300px;" class="m">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/midperiodreport/gradient-purple-high.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="300">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:0;"><![endif]-->
<div class="mj-column-px-0 h g mb-0" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:300px;"><![endif]-->
<div class="z h fz dx nh xr c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="border:none;vertical-align:middle;padding:24px 24px 24px 24px;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x qk yg" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Nearly there.</p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf yg" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">You are getting close to your ESFOC goal.</p></div>
</td>
</tr>
<tr>
<td style="font-size:0;padding:0;padding-bottom:8px;word-break:break-word;" aria-hidden="true">
<div style="height:4px;line-height:4px;">&#8202;</div>
</td>
</tr>
<tr>
<td align="left" class="b tn xb p7 ki qkk" style="font-size:0;padding:0;padding-bottom:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;width:200px;line-height:100%;">
<tbody>
<tr>
<td align="center" bgcolor="#000000" class="co" role="presentation" style="background:#000000;border:none;border-radius:10px 10px 10px 10px;cursor:auto;mso-padding-alt:12px 0px 12px 0px;vertical-align:middle;" valign="middle">
<!--[if mso]><v:roundrect style="width:198px;height:47px;v-text-anchor:middle;" arcsize="43%" fill="t" stroke="f" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word"><w:anchorlock/><v:fill type="solid" color="#000000" /><v:textbox inset="0,0,0,0"><center><![endif]-->
<a href="#insertUrlLink" class="co" style="display:inline-block;width:200px;background-color:#000000;color:#ffffff;font-family:'Futura', 'Arial', sans-serif;font-size:13px;font-weight:normal;line-height:100%;margin:0;text-decoration:none;text-transform:none;padding:12px 0px 12px 0px;mso-padding-alt:0;border-radius:10px 10px 10px 10px;" target="_blank">
<span style="font-size:18px;font-family:'Futura', 'Arial', sans-serif;font-weight:700;color:#ffffff;line-height:133%;mso-line-height-alt:24px;">How close am I?</span>
</a>
<!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r lp ey t7 ys pb" style="background:#e5f8fa;background-color:#e5f8fa;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#e5f8fa;background-color:#e5f8fa;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:568px;"><![endif]-->
<div class="o h w" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:38px;"><![endif]-->
<div class="v hsq p3 c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:6.7316%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 0px 8px 0px;" bgcolor="transparent" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:38px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/newbehaviour/footer_wheel.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="38">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:221px;"><![endif]-->
<div class="oc hsq rd zx yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:39.0431%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background-color: #c3eff3; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 12px 8px 12px;" bgcolor="#c3eff3" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:left;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">You decide when it is <span style="font-weight:700;">safe and practical </span>to save fuel.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h g p3" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:38px;"><![endif]-->
<div class="v hsq p3 c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:6.7316%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 0px 8px 0px;" bgcolor="transparent" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:38px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/maritime_footer_thankyou.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="38">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:221px;"><![endif]-->
<div class="rz h sq rd zx yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:39.043%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background-color: #c3eff3; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 12px 8px 12px;" bgcolor="#c3eff3" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:left;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">We and your company thank you for your hard work.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r pt-0 ey t7 ys pb yg" style="background:#e5f8fa;background-color:#e5f8fa;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#e5f8fa;background-color:#e5f8fa;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:568px;"><![endif]-->
<div class="p h yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x ae waa yg q8" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:center;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">If this email was not meant for you, please let us know by replying.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r lp ey t7 ys" style="background:#b4b4b7;background-color:#b4b4b7;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#b4b4b7;background-color:#b4b4b7;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 32px 16px 32px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h w" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:56px;"><![endif]-->
<div class="n hc" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:10.5544%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:54px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Black-Icon.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="54">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:4px;"><![endif]-->
<div class="s h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:0.7463%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:104px;"><![endif]-->
<div class="thn hc" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:19.5451%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i a yw" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:72px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Black.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="72">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:4px;"><![endif]-->
<div class="s h g" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:0.7463%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:366px;"><![endif]-->
<div class="cqe h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:68.4079%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="right" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:right;color:#000000;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">Any questions? You can simply reply to this email or find FAQs on the <a href="https://u11880263.ct.sendgrid.net/ls/click?upn=k55hJBaaYKnYHW4ARI-2BBXBqquf-2BtxNzjC6cpz6M71P103SgazTjF5Flj3DK8r7bR-2B9CKTId1iUXV6vIXaYgn3Q-3D-3DCwoC_CGdrXD359dka6t58CL7pvkMzfyXP3-2FqyuOQuIg7J1YQkWek6aoJE61PvdsZak0hC16CwjXnbJX0XiJXxR2JTDjI88xOYvwcWJg0ZZkz974yctxrsRTh-2BIZ3r-2FZk-2FpYhNXLDENg6rjsdAPRVW8-2FwdHXreMMHv1GJ5Fey5ow0FpW1TBy55h5JWwZ8VLLpgHNK28R1aLD-2BchmuyJuMbwQO2DNNsbeHTGOFAfAybX8PmzPmmBUsUiSbsiyyVbjk4yYezK5wO28mY52SQx0QIOirVdFunqMrhXGP-2BVWxSZYXsIWqGS4D8l-2F43xrQorSVS4Sc8F5018wDY4jEm4LGuwKUhlZz0iuaYisuNRoUCjIR7a98-3D" style="font-weight:700;color:#000000;text-decoration:none;" target="_blank"><span style="font-weight:700;text-decoration:underline;">support page</span></a> of your online account.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r ey ys" style="background:#000000;background-color:#000000;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#000000;background-color:#000000;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:4px 0px 4px 0px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:600px;"><![endif]-->
<div class="c2 h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x yc" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:8px;font-weight:400;line-height:125%;text-align:center;color:#9f9f9f;"><p style="Margin:0;mso-line-height-alt:10px;font-size:8px;line-height:125%;">&copy; SIGNOL 2025</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
</body>
</html>`,
    contentType: "HTML",
  },
  {
    id: "5f4d54e6e630837c4977ed25",
    createdAt: new Date(new Date().setFullYear(new Date().getFullYear() - 2)),
    type: "INAPP",
    category: "REPORT",
    isRead: false,
    title: "Captain Marinov, begin your Signol journey",
    template: "KICKOFF",
    content: `<!doctype html>
<html lang="en" dir="auto" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<title></title>
<!--[if !mso]><!-->
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<!--<![endif]-->
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<style type="text/css">

#outlook a { padding:0; }
body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
p { display:block;margin:13px 0; }
</style>
<!--[if mso]>
<noscript>
<xml>
<o:OfficeDocumentSettings>
<o:AllowPNG/>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml>
</noscript>
<![endif]-->
<!--[if lte mso 11]>
<style type="text/css">

.h { width:100% !important; }
</style>
<![endif]-->
<!--[if !mso]><!-->
<link href="https://fonts.googleapis.com/css?family=Roboto:400,700" rel="stylesheet" type="text/css">
<!--<![endif]-->
<style type="text/css">

@media only screen and (min-width:599px) {
.o { width:100% !important; max-width: 100%; }
.t { width:17.6056% !important; max-width: 17.6056%; }
.y { width:2.8169% !important; max-width: 2.8169%; }
.iw { width:79.5775% !important; max-width: 79.5775%; }
.c2 { width:600px !important; max-width: 600px; }
.k { width:536px !important; max-width: 536px; }
.w { width:14.4928% !important; max-width: 14.4928%; }
.f { width:2.8986% !important; max-width: 2.8986%; }
.ym { width:82.6086% !important; max-width: 82.6086%; }
.p { width:568px !important; max-width: 568px; }
.v { width:6.7316% !important; max-width: 6.7316%; }
.oc { width:39.0431% !important; max-width: 39.0431%; }
.rz { width:39.043% !important; max-width: 39.043%; }
.n { width:10.5544% !important; max-width: 10.5544%; }
.s { width:0.7463% !important; max-width: 0.7463%; }
.thn { width:19.5451% !important; max-width: 19.5451%; }
.cq { width:68.4079% !important; max-width: 68.4079%; }
}
</style>
<style media="screen and (min-width:599px)">
.moz-text-html .o { width:100% !important; max-width: 100%; }
.moz-text-html .t { width:17.6056% !important; max-width: 17.6056%; }
.moz-text-html .y { width:2.8169% !important; max-width: 2.8169%; }
.moz-text-html .iw { width:79.5775% !important; max-width: 79.5775%; }
.moz-text-html .c2 { width:600px !important; max-width: 600px; }
.moz-text-html .k { width:536px !important; max-width: 536px; }
.moz-text-html .w { width:14.4928% !important; max-width: 14.4928%; }
.moz-text-html .f { width:2.8986% !important; max-width: 2.8986%; }
.moz-text-html .ym { width:82.6086% !important; max-width: 82.6086%; }
.moz-text-html .p { width:568px !important; max-width: 568px; }
.moz-text-html .v { width:6.7316% !important; max-width: 6.7316%; }
.moz-text-html .oc { width:39.0431% !important; max-width: 39.0431%; }
.moz-text-html .rz { width:39.043% !important; max-width: 39.043%; }
.moz-text-html .n { width:10.5544% !important; max-width: 10.5544%; }
.moz-text-html .s { width:0.7463% !important; max-width: 0.7463%; }
.moz-text-html .thn { width:19.5451% !important; max-width: 19.5451%; }
.moz-text-html .cq { width:68.4079% !important; max-width: 68.4079%; }
</style>
<style type="text/css">

@media only screen and (max-width:598px) {
table.m { width: 100% !important; }
td.m { width: auto !important; }
}
</style>
<style type="text/css">

body {
-webkit-font-smoothing:antialiased;
-moz-osx-font-smoothing:grayscale;
}
a[x-apple-data-detectors] {
color: inherit !important;
text-decoration: none !important;
}
[data-markjs] { color: inherit; padding: 0; background: none; }
#MessageViewBody a {
color: inherit !important;
text-decoration: none!important;
}
[x-apple-data-detectors-type="calendar-event"] { color: inherit !important; -webkit-text-decoration-color: inherit !important; }
u + .emailify a[href^="tel:"],
u + .emailify a[href^="mailto:"],
u + .emailify a[href*="maps.google"] {
color: inherit !important;
text-decoration: none !important;
}div.wa { font-size: 0; }
@media only screen and (max-width:599px) {
.emailify { height:100% !important; margin:0 !important; padding:0 !important; width:100% !important; }
.m img { width: 100%!important; max-width: 100%!important; height: auto!important; }
.a img { height: auto!important; }
.p3 { display: none!important; max-width: 0!important; max-height: 0!important; overflow: hidden!important; mso-hide: all!important; }
td.b td { background-size: cover!important; }
div.r > table > tbody > tr > td { direction: ltr!important; }
img { background-color: transparent!important; }
div.r.l > table > tbody > tr > td, div.r.l > div > table > tbody > tr > td { padding-top:8px!important }
div.r.e > table > tbody > tr > td, div.r.e > div > table > tbody > tr > td { padding-right:16px!important }
div.r.t7 > table > tbody > tr > td, div.r.t7 > div > table > tbody > tr > td { padding-bottom:8px!important }
div.r.ys > table > tbody > tr > td, div.r.ys > div > table > tbody > tr > td { padding-left:16px!important }
td.x.qk span, td.x.qk p, td.x.qk a, td.x.qk ol, td.x.qk ul, td.x.qk div, td.x.qk { font-size:20px!important }
div.r.pt-0 > table > tbody > tr > td, div.r.pt-0 > div > table > tbody > tr > td { padding-top:0px!important }
div.r.pr-0 > table > tbody > tr > td, div.r.pr-0 > div > table > tbody > tr > td { padding-right:0px!important }
div.r.pb-0 > table > tbody > tr > td, div.r.pb-0 > div > table > tbody > tr > td { padding-bottom:0px!important }
div.r.pl-0 > table > tbody > tr > td, div.r.pl-0 > div > table > tbody > tr > td { padding-left:0px!important }
div.r.fz > table > tbody > tr > td, div.r.fz > div > table > tbody > tr > td { padding-top:24px!important }
div.r.nh > table > tbody > tr > td, div.r.nh > div > table > tbody > tr > td { padding-bottom:24px!important }
td.x.tn span, td.x.tn p, td.x.tn a, td.x.tn ol, td.x.tn ul, td.x.tn div, td.x.tn { font-size:14px!important }
td.x.lf span, td.x.lf p, td.x.lf a, td.x.lf ol, td.x.lf ul, td.x.lf div, td.x.lf { line-height:20px!important }
div.r.g > table > tbody > tr > td, div.r.g > div > table > tbody > tr > td { padding-top:16px!important }
div.r.ke > table > tbody > tr > td, div.r.ke > div > table > tbody > tr > td { padding-bottom:12px!important }
td.x.u span, td.x.u p, td.x.u a, td.x.u ol, td.x.u ul, td.x.u div, td.x.u { font-size:24px!important }
td.x.tnq span, td.x.tnq p, td.x.tnq a, td.x.tnq ol, td.x.tnq ul, td.x.tnq div, td.x.tnq { line-height:28px!important }
div.c.cw > table > tbody > tr > td { padding-top:12px!important }
div.c.e > table > tbody > tr > td { padding-right:16px!important }
div.c.ke > table > tbody > tr > td { padding-bottom:12px!important }
div.c.ys > table > tbody > tr > td { padding-left:16px!important }
td.b.tn a, td.b.tn span { font-size:14px!important }
td.b.xb > table { width:100%!important } td.xb > table > tbody > tr > td > a { display: block!important; width: 100%!important; padding-left: 0!important; padding-right: 0!important; }
td.b.xb > table { width:100%!important } td.xb > table > tbody > tr > td { width: 100%!important; padding-left: 0!important; padding-right: 0!important; }
div.z { width:48%!important; }
td.x.ae span, td.x.ae p, td.x.ae a, td.x.ae ol, td.x.ae ul, td.x.ae div, td.x.ae { font-size:8px!important }
td.x.waa span, td.x.waa p, td.x.waa a, td.x.waa ol, td.x.waa ul, td.x.waa div, td.x.waa { line-height:9px!important }
td.i.yw img, td.i.yw td { width:40px!important }
}
@media (prefers-color-scheme: dark) {div.r.qc, div.r.qc > table { background-color:#04535D!important; }
div.r.yg * { color:#FFFFFE!important }
div.r.fr, div.r.fr > table { background-color:#03A5B9!important; }
div.c.yg * { color:#FFFFFE!important }
div.r.cy, div.r.cy > table { background-color:#028292!important; }
div.r.pb, div.r.pb > table { background-color:#05606C!important; }
div.c.rd > table > tbody > tr > td { background-color:#04454E!important; }
td.x.yg * { color:#FFFFFE!important }
td.x.q8 a { color:#FFFFFE!important }
}
</style>
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no, url=no">
<meta name="x-apple-disable-message-reformatting">
<meta name="color-scheme" content="light dark">
<meta name="supported-color-schemes" content="light dark">
<!--[if gte mso 9]>
<style>
a:link {
mso-style-priority: 99;
color: inherit;
text-decoration: none;
}
a:visited {
mso-style-priority: 99;
color: inherit;
text-decoration: none;
}
li { margin-left: -1em !important }
table, td, p, div, span, ul, ol, li, a, h1, h2, h3, h4, h5, h6 {
mso-hyphenate: none;
}
sup, sub { font-size: 100% !important; }
img { background-color: transparent !important; }
</style>
<![endif]-->
<!--[if mso]>
<style>
.co { background: transparent !important; background-color: transparent !important; mso-padding-alt: 0px !important; padding: 0px !important; border: 0px !important; border-top: 0px !important; border-right: 0px !important; border-bottom: 0px !important; border-left: 0px !important; }
</style>
<![endif]-->
<!--[if mso]><!-- -->
<style>
.sq > table > tbody > tr > td { border-collapse: collapse; }
</style>
<!--<![endif]-->
</head>
<body lang="en" link="#000000" vlink="#000000" class="emailify" style="mso-line-height-rule: exactly; mso-hyphenate: none; word-wrap: normal; word-spacing: normal; background-color: #f5f5f5;">
<div style="background-color:#f5f5f5;" lang="en" dir="auto">
<!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e t7 ys qc yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:568px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:99px;"><![endif]-->
<div class="t hc" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:17.6056%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:99px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Blue.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="99">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:452px;"><![endif]-->
<div class="iw h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:79.5775%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="right" class="x qk" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial Black', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:right;color:#000000;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Let&rsquo;s Get Started</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r pt-0 pr-0 pb-0 pl-0" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:600px;"><![endif]-->
<div class="c2 h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i xb" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="m">
<tbody>
<tr>
<td style="width:600px;" class="m">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/kickoff/header_aviation.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r fz e nh ys fr yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:32px 32px 32px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Dear Captain Marinov,</p><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">&nbsp;</p><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Here are your personal Signol goals, based on fuel-saving actions you already know and perform.</p><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">&nbsp;</p><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Signol receives data via Demo API. We divide all vessel operations into small reporting intervals called "opportunities" between the following states: Sea Passage, At Berth, Manoeuvring, Anchor/Waiting and Drifting.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r g e ke ys qc yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:24px 32px 16px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x u tnq" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial Black', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:center;color:#000000;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Here are your goals for each 2 week period:</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys fr" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 24px 8px 24px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:552px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:80px;"><![endif]-->
<div class="w hyg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:14.4928%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:80px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/behaviours/bubble/purple_goal_10.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="80">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:16px;"><![endif]-->
<div class="f h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8986%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:455px;"><![endif]-->
<div class="ym h cw e ke ys sq c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:82.6086%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background: #d9c4fd; background-color: #d9c4fd; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 16px 24px 16px 24px;" bgcolor="#d9c4fd" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x qk" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial Black', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#9962f8;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Efficient SFOC (ESFOC)</p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">While underway, meet the vessel&rsquo;s expected ME SFOC value, on <span style="font-size:16px;font-family:'Futura', 'Arial Black', sans-serif;font-weight:700;line-height:131%;mso-line-height-alt:21px;">10 opportunities.</span></p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#8645f7;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Pre-Signol, you performed ESFOC on 9 opportunities in each 2 week period.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys fr" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 24px 8px 24px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:552px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:80px;"><![endif]-->
<div class="w hyg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:14.4928%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:80px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/behaviours/bubble/orange_goal_11.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="80">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:16px;"><![endif]-->
<div class="f h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8986%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:455px;"><![endif]-->
<div class="ym h cw e ke ys sq c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:82.6086%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background: #ffc59b; background-color: #ffc59b; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 16px 24px 16px 24px;" bgcolor="#ffc59b" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x qk" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial Black', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#ff6e05;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Optimal Trim (OT)</p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Trim the vessel according to the vessel's trim table, on <span style="font-size:16px;font-family:'Futura', 'Arial Black', sans-serif;font-weight:700;line-height:131%;mso-line-height-alt:21px;">11 opportunites.</span></p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#dc6006;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Pre-Signol, you performed OT on 9 opportunities in each 2 week period.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys fr" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 24px 8px 24px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:552px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:80px;"><![endif]-->
<div class="w hyg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:14.4928%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:80px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/behaviours/bubble/pink_goal_4.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="80">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:16px;"><![endif]-->
<div class="f h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8986%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:455px;"><![endif]-->
<div class="ym h cw e ke ys sq c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:82.6086%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background: #ffc2e6; background-color: #ffc2e6; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 16px 24px 16px 24px;" bgcolor="#ffc2e6" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x qk" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial Black', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#ff1585;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Prompt Departure (PD)</p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Ensure Actual Time of Departure from the ship's berth is within 2.5 hours of last cargo hose disconnection, on <span style="font-size:16px;font-family:'Futura', 'Arial Black', sans-serif;font-weight:700;line-height:131%;mso-line-height-alt:21px;">4 opportunites.</span></p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#da0f70;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Pre-Signol, you performed PD on 3 opportunities in each 2 week period.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys fr" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 24px 8px 24px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:552px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:80px;"><![endif]-->
<div class="w hyg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:14.4928%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:80px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/behaviours/bubble/teal_goal_9.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="80">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:16px;"><![endif]-->
<div class="f h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8986%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:455px;"><![endif]-->
<div class="ym h cw e ke ys sq c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:82.6086%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background: #bdf0e4; background-color: #bdf0e4; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 16px 24px 16px 24px;" bgcolor="#bdf0e4" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x qk" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial Black', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#2fcba7;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Efficient Auxiliary Engine Use (EAEU)</p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Limit excess running hours to 1 hour or less by loading the minimum number of auxiliary engines to meet demand, on <span style="font-size:16px;font-family:'Futura', 'Arial Black', sans-serif;font-weight:700;line-height:131%;mso-line-height-alt:21px;">9 opportunities</span>.</p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#1b9d7f;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Pre-Signol, you performed EAEU on 8 opportunities in each 2 week period.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r fz e nh ys fr yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:32px 32px 32px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Find out more about how we keep the goals fair for you in your online account.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r fz e nh ys fr" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:32px 16px 32px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:568px;"><![endif]-->
<div class="p h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="b tn xb" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;width:300px;line-height:100%;">
<tbody>
<tr>
<td align="center" bgcolor="#000000" class="co" role="presentation" style="background:#000000;border:none;border-radius:10px 10px 10px 10px;cursor:auto;mso-padding-alt:12px 0px 12px 0px;vertical-align:middle;" valign="middle">
<!--[if mso]><v:roundrect style="width:298px;height:52px;v-text-anchor:middle;" arcsize="38%" fill="t" stroke="f" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word"><w:anchorlock/><v:fill type="solid" color="#000000" /><v:textbox inset="0,0,0,0"><center><![endif]-->
<a href="{{APP_BASEURL}}/dashboard" class="co" style="display:inline-block;width:300px;background-color:#000000;color:#ffffff;font-family:'Futura', 'Arial Black', sans-serif;font-size:13px;font-weight:normal;line-height:100%;margin:0;text-decoration:none;text-transform:none;padding:12px 0px 12px 0px;mso-padding-alt:0;border-radius:10px 10px 10px 10px;" target="_blank">
<span style="font-size:18px;font-family:'Futura', 'Arial Black', sans-serif;font-weight:700;color:#ffffff;line-height:156%;mso-line-height-alt:28px;">Explore my online account</span>
</a>
<!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys fr" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 16px 0px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:568px;"><![endif]-->
<div class="p h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td style="font-size:0;padding:0;word-break:break-word;" aria-hidden="true">
<div style="height:8px;line-height:8px;">&#8202;</div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r fz e nh ys cy yg" style="background:#65d4e2;background-color:#65d4e2;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#65d4e2;background-color:#65d4e2;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:32px 32px 32px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="background:transparent;border:none;vertical-align:middle;padding:8px 8px 8px 8px;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x qk" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial Black', sans-serif;font-size:28px;font-weight:700;line-height:132%;text-align:left;color:#ffffff;"><p style="Margin:0;mso-line-height-alt:37px;font-size:28px;line-height:132%;">Will my goal change?</p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#ffffff;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Don't worry, Signol will not increase your goal anytime soon. If you have fewer opportunities because a behaviour is not possible, for example, during time you are on shore or in poor weather conditions, Signol will adjust your goal to keep it fair.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e t7 ys pb" style="background:#e5f8fa;background-color:#e5f8fa;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#e5f8fa;background-color:#e5f8fa;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:568px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:38px;"><![endif]-->
<div class="v hsq p3 c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:6.7316%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background: transparent; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 0px 8px 0px;" bgcolor="transparent" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:38px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/newbehaviour/footer_wheel.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="38">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:221px;"><![endif]-->
<div class="oc hsq rd z yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:39.0431%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background: #c3eff3; background-color: #c3eff3; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 12px 8px 12px;" bgcolor="#c3eff3" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:left;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">You decide when it is <span style="font-weight:700;">safe and practical </span>to save fuel.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h p3" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:38px;"><![endif]-->
<div class="v hsq p3 c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:6.7316%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background: transparent; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 0px 8px 0px;" bgcolor="transparent" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:38px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/maritime_footer_thankyou.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="38">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:221px;"><![endif]-->
<div class="rz h sq rd z yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:39.043%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background: #c3eff3; background-color: #c3eff3; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 12px 8px 12px;" bgcolor="#c3eff3" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:left;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">We and your company thank you for your hard work.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r pt-0 e t7 ys pb yg" style="background:#e5f8fa;background-color:#e5f8fa;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#e5f8fa;background-color:#e5f8fa;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:568px;"><![endif]-->
<div class="p h yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x ae waa yg q8" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:center;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">If this email was not meant for you, please let us know by replying.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e t7 ys" style="background:#b4b4b7;background-color:#b4b4b7;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#b4b4b7;background-color:#b4b4b7;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 32px 16px 32px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:56px;"><![endif]-->
<div class="n hc" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:10.5544%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:54px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Black-Icon.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="54">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:4px;"><![endif]-->
<div class="s h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:0.7463%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:104px;"><![endif]-->
<div class="thn hc" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:19.5451%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i a yw" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:72px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Black.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="72">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:4px;"><![endif]-->
<div class="s h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:0.7463%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:366px;"><![endif]-->
<div class="cq h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:68.4079%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="right" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:right;color:#000000;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">Any questions? You can simply reply to this email or find FAQs on the <a href="https://u11880263.ct.sendgrid.net/ls/click?upn=k55hJBaaYKnYHW4ARI-2BBXBqquf-2BtxNzjC6cpz6M71P103SgazTjF5Flj3DK8r7bR-2B9CKTId1iUXV6vIXaYgn3Q-3D-3DCwoC_CGdrXD359dka6t58CL7pvkMzfyXP3-2FqyuOQuIg7J1YQkWek6aoJE61PvdsZak0hC16CwjXnbJX0XiJXxR2JTDjI88xOYvwcWJg0ZZkz974yctxrsRTh-2BIZ3r-2FZk-2FpYhNXLDENg6rjsdAPRVW8-2FwdHXreMMHv1GJ5Fey5ow0FpW1TBy55h5JWwZ8VLLpgHNK28R1aLD-2BchmuyJuMbwQO2DNNsbeHTGOFAfAybX8PmzPmmBUsUiSbsiyyVbjk4yYezK5wO28mY52SQx0QIOirVdFunqMrhXGP-2BVWxSZYXsIWqGS4D8l-2F43xrQorSVS4Sc8F5018wDY4jEm4LGuwKUhlZz0iuaYisuNRoUCjIR7a98-3D" style="font-weight:700;color:#000000;text-decoration:none;" target="_blank"><span style="font-weight:700;text-decoration:underline;">support page</span></a> of your online account.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
</body>
</html>`,
    contentType: "HTML",
  },
  {
    id: "5f4d54e6e630837c4977ed26",
    createdAt: new Date(new Date().setFullYear(new Date().getFullYear() - 2)),
    type: "INAPP",
    category: "OTHER",
    isRead: false,
    title: "Captain Marinov, welcome to Signol",
    template: "NEWUSER",
    content: `<!doctype html>
<html lang="en" dir="auto" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<title></title>
<!--[if !mso]><!-->
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<!--<![endif]-->
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<style type="text/css">

#outlook a { padding:0; }
body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
p { display:block;margin:13px 0; }
</style>
<!--[if mso]>
<noscript>
<xml>
<o:OfficeDocumentSettings>
<o:AllowPNG/>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml>
</noscript>
<![endif]-->
<!--[if lte mso 11]>
<style type="text/css">

.h { width:100% !important; }
</style>
<![endif]-->
<!--[if !mso]><!-->
<link href="https://fonts.googleapis.com/css?family=Roboto:400,700" rel="stylesheet" type="text/css">
<!--<![endif]-->
<style type="text/css">

@media only screen and (min-width:599px) {
.o { width:100% !important; max-width: 100%; }
.t { width:17.6056% !important; max-width: 17.6056%; }
.y { width:2.8169% !important; max-width: 2.8169%; }
.iw { width:79.5775% !important; max-width: 79.5775%; }
.c2 { width:600px !important; max-width: 600px; }
.k { width:536px !important; max-width: 536px; }
.s { width:22.3881% !important; max-width: 22.3881%; }
.x5 { width:2.9851% !important; max-width: 2.9851%; }
.bp { width:74.6268% !important; max-width: 74.6268%; }
.d { width:520px !important; max-width: 520px; }
.thn { width:17.8612% !important; max-width: 17.8612%; }
.q { width:1.4085% !important; max-width: 1.4085%; }
.sga { width:80.5542% !important; max-width: 80.5542%; }
.n { width:0.1761% !important; max-width: 0.1761%; }
.v { width:6.7316% !important; max-width: 6.7316%; }
.oc { width:39.0431% !important; max-width: 39.0431%; }
.rz { width:39.043% !important; max-width: 39.043%; }
.p { width:568px !important; max-width: 568px; }
.nb { width:10.5544% !important; max-width: 10.5544%; }
.s0 { width:0.7463% !important; max-width: 0.7463%; }
.thn0 { width:19.5451% !important; max-width: 19.5451%; }
.cq { width:68.4079% !important; max-width: 68.4079%; }
}
</style>
<style media="screen and (min-width:599px)">
.moz-text-html .o { width:100% !important; max-width: 100%; }
.moz-text-html .t { width:17.6056% !important; max-width: 17.6056%; }
.moz-text-html .y { width:2.8169% !important; max-width: 2.8169%; }
.moz-text-html .iw { width:79.5775% !important; max-width: 79.5775%; }
.moz-text-html .c2 { width:600px !important; max-width: 600px; }
.moz-text-html .k { width:536px !important; max-width: 536px; }
.moz-text-html .s { width:22.3881% !important; max-width: 22.3881%; }
.moz-text-html .x5 { width:2.9851% !important; max-width: 2.9851%; }
.moz-text-html .bp { width:74.6268% !important; max-width: 74.6268%; }
.moz-text-html .d { width:520px !important; max-width: 520px; }
.moz-text-html .thn { width:17.8612% !important; max-width: 17.8612%; }
.moz-text-html .q { width:1.4085% !important; max-width: 1.4085%; }
.moz-text-html .sga { width:80.5542% !important; max-width: 80.5542%; }
.moz-text-html .n { width:0.1761% !important; max-width: 0.1761%; }
.moz-text-html .v { width:6.7316% !important; max-width: 6.7316%; }
.moz-text-html .oc { width:39.0431% !important; max-width: 39.0431%; }
.moz-text-html .rz { width:39.043% !important; max-width: 39.043%; }
.moz-text-html .p { width:568px !important; max-width: 568px; }
.moz-text-html .nb { width:10.5544% !important; max-width: 10.5544%; }
.moz-text-html .s0 { width:0.7463% !important; max-width: 0.7463%; }
.moz-text-html .thn0 { width:19.5451% !important; max-width: 19.5451%; }
.moz-text-html .cq { width:68.4079% !important; max-width: 68.4079%; }
</style>
<style type="text/css">

@media only screen and (max-width:598px) {
table.m { width: 100% !important; }
td.m { width: auto !important; }
}
</style>
<style type="text/css">

body {
-webkit-font-smoothing:antialiased;
-moz-osx-font-smoothing:grayscale;
}
a[x-apple-data-detectors] {
color: inherit !important;
text-decoration: none !important;
}
[data-markjs] { color: inherit; padding: 0; background: none; }
#MessageViewBody a {
color: inherit !important;
text-decoration: none!important;
}
[x-apple-data-detectors-type="calendar-event"] { color: inherit !important; -webkit-text-decoration-color: inherit !important; }
u + .emailify a[href^="tel:"],
u + .emailify a[href^="mailto:"],
u + .emailify a[href*="maps.google"] {
color: inherit !important;
text-decoration: none !important;
}div.wa { font-size: 0; }
@media only screen and (max-width:599px) {
.emailify { height:100% !important; margin:0 !important; padding:0 !important; width:100% !important; }
.m img { width: 100%!important; max-width: 100%!important; height: auto!important; }
.a img { height: auto!important; }
.p3 { display: none!important; max-width: 0!important; max-height: 0!important; overflow: hidden!important; mso-hide: all!important; }
td.b td { background-size: cover!important; }
div.r > table > tbody > tr > td { direction: ltr!important; }
img { background-color: transparent!important; }
div.r.l > table > tbody > tr > td, div.r.l > div > table > tbody > tr > td { padding-top:8px!important }
div.r.e > table > tbody > tr > td, div.r.e > div > table > tbody > tr > td { padding-right:16px!important }
div.r.t7 > table > tbody > tr > td, div.r.t7 > div > table > tbody > tr > td { padding-bottom:8px!important }
div.r.ys > table > tbody > tr > td, div.r.ys > div > table > tbody > tr > td { padding-left:16px!important }
td.x.qk span, td.x.qk p, td.x.qk a, td.x.qk ol, td.x.qk ul, td.x.qk div, td.x.qk { font-size:20px!important }
div.r.pt-0 > table > tbody > tr > td, div.r.pt-0 > div > table > tbody > tr > td { padding-top:0px!important }
div.r.pr-0 > table > tbody > tr > td, div.r.pr-0 > div > table > tbody > tr > td { padding-right:0px!important }
div.r.pb-0 > table > tbody > tr > td, div.r.pb-0 > div > table > tbody > tr > td { padding-bottom:0px!important }
div.r.pl-0 > table > tbody > tr > td, div.r.pl-0 > div > table > tbody > tr > td { padding-left:0px!important }
div.r.eya > table > tbody > tr > td, div.r.eya > div > table > tbody > tr > td { padding-top:32px!important }
div.r.oi > table > tbody > tr > td, div.r.oi > div > table > tbody > tr > td { padding-bottom:16px!important }
td.x.tn span, td.x.tn p, td.x.tn a, td.x.tn ol, td.x.tn ul, td.x.tn div, td.x.tn { font-size:14px!important }
td.x.lf span, td.x.lf p, td.x.lf a, td.x.lf ol, td.x.lf ul, td.x.lf div, td.x.lf { line-height:20px!important }
div.w.g > table > tbody > tr > td, div.w.g > div > table > tbody > tr > td { padding-top:16px!important; }
div.w.e > table > tbody > tr > td, div.w.e > div > table > tbody > tr > td { padding-right:16px!important; }
div.w.oi > table > tbody > tr > td, div.w.oi > div > table > tbody > tr > td { padding-bottom:16px!important; }
div.w.ys > table > tbody > tr > td, div.w.ys > div > table > tbody > tr > td { padding-left:16px!important; }
div.r.g > table > tbody > tr > td, div.r.g > div > table > tbody > tr > td { padding-top:16px!important }
div.r.nh > table > tbody > tr > td, div.r.nh > div > table > tbody > tr > td { padding-bottom:24px!important }
div.r.f > table > tbody > tr > td, div.r.f > div > table > tbody > tr > td { padding-top:24px!important }
div.r.mg > table > tbody > tr > td, div.r.mg > div > table > tbody > tr > td { padding-bottom:32px!important }
td.b.tn a, td.b.tn span { font-size:14px!important }
td.b.xb > table { width:100%!important } td.xb > table > tbody > tr > td > a { display: block!important; width: 100%!important; padding-left: 0!important; padding-right: 0!important; }
td.b.xb > table { width:100%!important } td.xb > table > tbody > tr > td { width: 100%!important; padding-left: 0!important; padding-right: 0!important; }
div.r.j > table > tbody > tr > td, div.r.j > div > table > tbody > tr > td { padding-right:8px!important }
div.r.dhn > table > tbody > tr > td, div.r.dhn > div > table > tbody > tr > td { padding-left:8px!important }
div.xv { width:46%!important; }
td.x.ae span, td.x.ae p, td.x.ae a, td.x.ae ol, td.x.ae ul, td.x.ae div, td.x.ae { font-size:8px!important }
td.x.waa span, td.x.waa p, td.x.waa a, td.x.waa ol, td.x.waa ul, td.x.waa div, td.x.waa { line-height:9px!important }
td.i.yw img, td.i.yw td { width:40px!important }
}
@media (prefers-color-scheme: dark) {div.r.pb, div.r.pb > table { background-color:#05606C!important; }
div.r.yg * { color:#FFFFFE!important }
div.r.fr, div.r.fr > table { background-color:#03A5B9!important; }
div.w.fr, div.w.fr > div > table, div.w.fr > table, div.w.fr > table > tbody > tr > td { background-color:#03A5B9!important; }
div.c.rd > table > tbody > tr > td { background-color:#04454E!important; }
div.c.yg * { color:#FFFFFE!important }
td.x.yg * { color:#FFFFFE!important }
td.x.q8 a { color:#FFFFFE!important }
}
</style>
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no, url=no">
<meta name="x-apple-disable-message-reformatting">
<meta name="color-scheme" content="light dark">
<meta name="supported-color-schemes" content="light dark">
<!--[if gte mso 9]>
<style>
a:link {
mso-style-priority: 99;
color: inherit;
text-decoration: none;
}
a:visited {
mso-style-priority: 99;
color: inherit;
text-decoration: none;
}
li { margin-left: -1em !important }
table, td, p, div, span, ul, ol, li, a, h1, h2, h3, h4, h5, h6 {
mso-hyphenate: none;
}
sup, sub { font-size: 100% !important; }
img { background-color: transparent !important; }
</style>
<![endif]-->
<!--[if mso]>
<style>
.co { background: transparent !important; background-color: transparent !important; mso-padding-alt: 0px !important; padding: 0px !important; border: 0px !important; border-top: 0px !important; border-right: 0px !important; border-bottom: 0px !important; border-left: 0px !important; }
</style>
<![endif]-->
<!--[if mso]><!-- -->
<style>
.sq > table > tbody > tr > td { border-collapse: collapse; }
</style>
<!--<![endif]-->
</head>
<body lang="en" link="#000000" vlink="#000000" class="emailify" style="mso-line-height-rule: exactly; mso-hyphenate: none; word-wrap: normal; word-spacing: normal; background-color: #f5f5f5;">
<div style="background-color:#f5f5f5;" lang="en" dir="auto">
<!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e t7 ys pb yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:568px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:99px;"><![endif]-->
<div class="t hc" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:17.6056%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:99px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Blue.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="99">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:452px;"><![endif]-->
<div class="iw h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:79.5775%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="right" class="x qk" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial Black', sans-serif;font-size:28px;font-weight:700;line-height:143%;text-align:right;color:#000000;"><p style="Margin:0;mso-line-height-alt:40px;font-size:28px;line-height:143%;">Welcome</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r pt-0 pr-0 pb-0 pl-0" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:600px;"><![endif]-->
<div class="c2 h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i xb" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="m">
<tbody>
<tr>
<td style="width:600px;" class="m">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/newuser/co2_shipping.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r eya e oi ys fr yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:32px 32px 16px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Dear Captain Marinov,</p><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">&nbsp;</p><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">At Signol, we respect your expertise and years of experience. We want to celebrate the great work you already do to save fuel - Signol is all about positive recognition.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600" bgcolor="#fffffe"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="w g e oi ys fr" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:568px;" width="568"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys pb" style="background:#dff9f3;background-color:#dff9f3;margin:0px auto;border-radius:20px 20px 20px 20px;max-width:568px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#dff9f3;background-color:#dff9f3;width:100%;border-radius:20px 20px 20px 20px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:120px;"><![endif]-->
<div class="s hsq p3 c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:22.3881%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse: separate; border-spacing: 0px; background: transparent; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle;" width="100%" bgcolor="transparent" valign="middle">
<tbody>
<tr>
<td align="left" class="i" style="border-collapse: separate; border-spacing: 0px; font-size: 0px; padding: 0; word-break: break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:120px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/newuser/welcome_insight.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="120">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:16px;"><![endif]-->
<div class="x5 h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.9851%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:399px;"><![endif]-->
<div class="bp h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:74.6268%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="background:transparent;border:none;vertical-align:middle;padding:8px 8px 8px 8px;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf" style="font-size:0;padding-bottom:8px;word-break:break-word;">
<div style="font-family:'Futura', 'Arial Black', sans-serif;font-size:18px;font-weight:700;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Did you know?</p></div>
</td>
</tr>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">On average, Demo Line officers save 2.6 MT of fuel per month by reducing excess auxiliary engine running hours. You're already working hard to reduce emissions.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r g e nh ys fr yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 32px 32px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">We know how busy you are so you do not need to fill in any new reports for Signol. Tomorrow, we will email you your personalised goals. Then our emails will simply update you on your progress and achievements based on data we already receive from your vessel.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600" bgcolor="#fffffe"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="w e ys fr" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 24px 0px 24px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td width="600px"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:552px;" width="552"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys pb" style="background:#65d4e2;background-color:#65d4e2;margin:0px auto;border-radius:10px 10px 10px 10px;max-width:552px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#65d4e2;background-color:#65d4e2;width:100%;border-radius:10px 10px 10px 10px;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:12px 16px 12px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:520px;"><![endif]-->
<div class="d h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="i xb" style="font-size:0;padding:0;padding-bottom:8px;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="m">
<tbody>
<tr>
<td style="width:520px;" class="m">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/newuser/shipping_CASH_donation.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="520">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td align="center" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial Black', sans-serif;font-size:18px;font-weight:700;line-height:133%;text-align:center;color:#ffffff;"><p style="Margin:0;mso-line-height-alt:24px;font-size:18px;line-height:133%;">Demo Line will donate $5 to the Ukraine Humanitarian Appeal for every goal you achieve.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r f e pb-0 ys fr yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:32px 32px 0px 32px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Futura', 'Arial Black', sans-serif;font-size:18px;font-weight:700;line-height:156%;text-align:center;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Curious to learn more about Signol?</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r g e mg ys fr yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:32px 32px 32px 32px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="b tn xb" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;width:276px;line-height:100%;">
<tbody>
<tr>
<td align="center" bgcolor="#000000" class="co" role="presentation" style="background:#000000;border:none;border-radius:10px 10px 10px 10px;cursor:auto;mso-padding-alt:12px 0px 12px 0px;vertical-align:middle;" valign="middle">
<!--[if mso]><v:roundrect style="width:274px;height:52px;v-text-anchor:middle;" arcsize="38%" fill="t" stroke="f" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word"><w:anchorlock/><v:fill type="solid" color="#000000" /><v:textbox inset="0,0,0,0"><center><![endif]-->
<a href="{{APP_BASEURL}}" class="co" style="display:inline-block;width:276px;background-color:#000000;color:#ffffff;font-family:'Futura', 'Arial Black', sans-serif;font-size:13px;font-weight:normal;line-height:100%;margin:0;text-decoration:none;text-transform:none;padding:12px 0px 12px 0px;mso-padding-alt:0;border-radius:10px 10px 10px 10px;" target="_blank">
<span style="font-size:18px;font-family:'Futura', 'Arial Black', sans-serif;font-weight:700;color:#ffffff;line-height:156%;letter-spacing:0.4px;mso-line-height-alt:28px;">Visit my online account</span>
</a>
<!--[if mso]></center></v:textbox></v:roundrect><![endif]-->
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r g e nh ys fr yg" style="background:#fffffe;background-color:#fffffe;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#fffffe;background-color:#fffffe;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 32px 32px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="x tn lf" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:left;color:#000000;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">Your online account is already set up and ready to use. You just need to set your password. Your username is:&nbsp;<span style="font-weight:700;">B1234</span></p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r e ys pb yg" style="background:#c3eff3;background-color:#c3eff3;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#c3eff3;background-color:#c3eff3;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:8px 32px 0px 32px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:536px;"><![endif]-->
<div class="k h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x tn" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:18px;font-weight:400;line-height:156%;text-align:center;color:#04454e;"><p style="Margin:0;mso-line-height-alt:28px;font-size:18px;line-height:156%;">In collaboration with</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e t7 ys pb" style="background:#c3eff3;background-color:#c3eff3;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#c3eff3;background-color:#c3eff3;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:568px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:101px;"><![endif]-->
<div class="thn hsq c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:17.8612%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse: separate; border-spacing: 0px; background: #fffffe; background-color: #fffffe; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle;" width="100%" bgcolor="#fffffe" valign="middle">
<tbody>
<tr>
<td align="center" class="i" style="border-collapse: separate; border-spacing: 0px; font-size: 0px; padding: 0; word-break: break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:101px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/SGL_signature1.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="101">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:8px;"><![endif]-->
<div class="q h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:1.4085%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:457px;"><![endif]-->
<div class="sga h sq c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:80.5542%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse: separate; border-spacing: 0px; background: #fffffe; background-color: #fffffe; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle;" width="100%" bgcolor="#fffffe" valign="middle">
<tbody>
<tr>
<td align="center" class="i xb" style="border-collapse: separate; border-spacing: 0px; font-size: 0px; padding: 0; word-break: break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;" class="m">
<tbody>
<tr>
<td style="width:451px;" class="m">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/DA/square_logo.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="451">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:1px;"><![endif]-->
<div class="n h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:0.1761%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l j t7 dhn pb" style="background:#e5f8fa;background-color:#e5f8fa;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#e5f8fa;background-color:#e5f8fa;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 16px 16px 16px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:568px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:38px;"><![endif]-->
<div class="v hsq p3 c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:6.7316%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background: transparent; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 0px 8px 0px;" bgcolor="transparent" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:38px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/newbehaviour/footer_wheel.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="38">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:221px;"><![endif]-->
<div class="oc hsq rd xv yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:39.0431%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background: #c3eff3; background-color: #c3eff3; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 12px 8px 12px;" bgcolor="#c3eff3" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:left;color:#04454e;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">You decide when it is <span style="font-weight:700;">safe and practical </span>to save fuel.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h p3" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:38px;"><![endif]-->
<div class="v hsq p3 c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:6.7316%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background: transparent; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 0px 8px 0px;" bgcolor="transparent" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="center" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:38px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/maritime_footer_thankyou.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="38">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:15px;"><![endif]-->
<div class="y h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:2.8169%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:221px;"><![endif]-->
<div class="rz h sq rd xv yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:39.043%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0px;">
<tbody>
<tr>
<td style="border-collapse: separate; border-spacing: 0px; background: #c3eff3; background-color: #c3eff3; border: none; border-radius: 10px 10px 10px 10px; vertical-align: middle; padding: 8px 12px 8px 12px;" bgcolor="#c3eff3" valign="middle">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td align="left" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:left;color:#04454e;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">We and your company thank you for your hard work.</p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r pt-0 e t7 ys pb yg" style="background:#e5f8fa;background-color:#e5f8fa;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#e5f8fa;background-color:#e5f8fa;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:0px 16px 16px 16px;text-align:left;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;vertical-align:middle;width:568px;"><![endif]-->
<div class="p h yg c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="center" class="x ae waa yg q8" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:center;color:#05606c;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">If this email was not meant for you, please let us know by replying.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:600px;" width="600"><tr><td style="line-height:0;font-size:0;mso-line-height-rule:exactly;"><![endif]-->
<div class="r l e t7 ys" style="background:#b4b4b7;background-color:#b4b4b7;margin:0px auto;max-width:600px;">
<table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#b4b4b7;background-color:#b4b4b7;width:100%;">
<tbody>
<tr>
<td style="border:none;direction:ltr;font-size:0;padding:16px 32px 16px 32px;text-align:center;">
<!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td style="width:536px;"><![endif]-->
<div class="o h wa" style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr;">
<!--[if mso | IE]><table border="0" cellpadding="0" cellspacing="0" role="presentation"><tr><td style="vertical-align:middle;width:56px;"><![endif]-->
<div class="nb hc" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:10.5544%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:54px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Black-Icon.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="54">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:4px;"><![endif]-->
<div class="s0 h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:0.7463%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:104px;"><![endif]-->
<div class="thn0 hc" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:19.5451%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="left" class="i a yw" style="font-size:0;padding:0;word-break:break-word;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;">
<tbody>
<tr>
<td style="width:72px;">
<img alt src="https://signol-email-images.s3.eu-west-2.amazonaws.com/customers/SG/Logo-Black.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="72">
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:top;width:4px;"><![endif]-->
<div class="s0 h" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:0.7463%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
<tr>
<td style="vertical-align:top;padding:0;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
<tbody>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td><td style="vertical-align:middle;width:366px;"><![endif]-->
<div class="cq h c" style="font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:68.4079%;">
<table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border:none;vertical-align:middle;" width="100%">
<tbody>
<tr>
<td align="right" class="x ae waa" style="font-size:0;word-break:break-word;">
<div style="font-family:'Roboto', 'Arial', sans-serif;font-size:12px;font-weight:400;line-height:117%;text-align:right;color:#000000;"><p style="Margin:0;mso-line-height-alt:14px;font-size:12px;line-height:117%;">Any questions? You can simply reply to this email or find FAQs on the <a href="https://u11880263.ct.sendgrid.net/ls/click?upn=k55hJBaaYKnYHW4ARI-2BBXBqquf-2BtxNzjC6cpz6M71P103SgazTjF5Flj3DK8r7bR-2B9CKTId1iUXV6vIXaYgn3Q-3D-3DCwoC_CGdrXD359dka6t58CL7pvkMzfyXP3-2FqyuOQuIg7J1YQkWek6aoJE61PvdsZak0hC16CwjXnbJX0XiJXxR2JTDjI88xOYvwcWJg0ZZkz974yctxrsRTh-2BIZ3r-2FZk-2FpYhNXLDENg6rjsdAPRVW8-2FwdHXreMMHv1GJ5Fey5ow0FpW1TBy55h5JWwZ8VLLpgHNK28R1aLD-2BchmuyJuMbwQO2DNNsbeHTGOFAfAybX8PmzPmmBUsUiSbsiyyVbjk4yYezK5wO28mY52SQx0QIOirVdFunqMrhXGP-2BVWxSZYXsIWqGS4D8l-2F43xrQorSVS4Sc8F5018wDY4jEm4LGuwKUhlZz0iuaYisuNRoUCjIR7a98-3D" style="font-weight:700;color:#000000;text-decoration:none;" target="_blank"><span style="font-weight:700;text-decoration:underline;">support page</span></a> of your online account.</p></div>
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</td>
</tr>
</tbody>
</table>
</div>
<!--[if mso | IE]></td></tr></table><![endif]-->
</div>
</body>
</html>`,
    contentType: "HTML",
  },
];
